function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #006cc4;\n      }\n\n      .cls-2 {\n        fill: #0085f4;\n      }\n\n      .cls-3 {\n        fill: #0885e4;\n      }\n\n      .cls-4 {\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "vithack-coomunity-logo",
  transform: "translate(-151.286 -247.922)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_175",
  "data-name": "Group 175",
  transform: "translate(180.12 256.222)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_139",
  "data-name": "Group 139",
  transform: "translate(11.811)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_138",
  "data-name": "Group 138"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_137",
  "data-name": "Group 137"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_136",
  "data-name": "Group 136"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_135",
  "data-name": "Group 135"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1029",
  "data-name": "Path 1029",
  className: "cls-1",
  d: "M502.262,318.859v10.854l-3.6-2.061v-6.719Z",
  transform: "translate(-498.658 -318.859)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_144",
  "data-name": "Group 144",
  transform: "translate(0 8.445)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_143",
  "data-name": "Group 143"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_142",
  "data-name": "Group 142"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_141",
  "data-name": "Group 141"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_140",
  "data-name": "Group 140"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1030",
  "data-name": "Path 1030",
  className: "cls-2",
  d: "M404.925,399.461V394.07l3.561-2.089v-.946h-5.912l-4.857,4.855v3.571Z",
  transform: "translate(-397.717 -391.035)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_149",
  "data-name": "Group 149",
  transform: "translate(8.174 9.932)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_148",
  "data-name": "Group 148"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_147",
  "data-name": "Group 147"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_146",
  "data-name": "Group 146"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_145",
  "data-name": "Group 145"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1031",
  "data-name": "Path 1031",
  className: "cls-1",
  d: "M467.578,405.849l3.637-2.108,3.6,2.108v4.832h-7.24Z",
  transform: "translate(-467.578 -403.742)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_154",
  "data-name": "Group 154",
  transform: "translate(16.433 4.423)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_153",
  "data-name": "Group 153"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_152",
  "data-name": "Group 152"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_151",
  "data-name": "Group 151"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_150",
  "data-name": "Group 150"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1032",
  "data-name": "Path 1032",
  className: "cls-2",
  d: "M538.16,356.658l3.96,2.3V364.2l-3.96,2.24Z",
  transform: "translate(-538.16 -356.658)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_159",
  "data-name": "Group 159",
  transform: "translate(16.433 11.219)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_158",
  "data-name": "Group 158"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_157",
  "data-name": "Group 157"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_156",
  "data-name": "Group 156"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_155",
  "data-name": "Group 155"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1033",
  "data-name": "Path 1033",
  className: "cls-2",
  d: "M538.16,418.911l7.321-4.171v5.653H538.16Z",
  transform: "translate(-538.16 -414.741)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_164",
  "data-name": "Group 164",
  transform: "translate(26.394 11.22)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_163",
  "data-name": "Group 163"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_162",
  "data-name": "Group 162"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_161",
  "data-name": "Group 161"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_160",
  "data-name": "Group 160"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1034",
  "data-name": "Path 1034",
  className: "cls-1",
  d: "M623.307,414.753l-.013,5.651h5.634Z",
  transform: "translate(-623.294 -414.753)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_169",
  "data-name": "Group 169",
  transform: "translate(21.433 8.445)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_168",
  "data-name": "Group 168"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_167",
  "data-name": "Group 167"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_166",
  "data-name": "Group 166"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_165",
  "data-name": "Group 165"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1035",
  "data-name": "Path 1035",
  className: "cls-3",
  d: "M580.893,393.972l2.08-1.176h3.307l6.671,6.689v-3.6l-4.842-4.85h-7.214Z",
  transform: "translate(-580.893 -391.035)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_174",
  "data-name": "Group 174",
  transform: "translate(24.768 11.22)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_173",
  "data-name": "Group 173"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_172",
  "data-name": "Group 172"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_171",
  "data-name": "Group 171"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_170",
  "data-name": "Group 170"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1036",
  "data-name": "Path 1036",
  className: "cls-1",
  d: "M611.042,414.753H609.4V420.4h1.625Z",
  transform: "translate(-609.403 -414.753)"
}))))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_212",
  "data-name": "Group 212",
  transform: "translate(151.286 276.967)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_179",
  "data-name": "Group 179",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_178",
  "data-name": "Group 178"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_177",
  "data-name": "Group 177"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_176",
  "data-name": "Group 176"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1037",
  "data-name": "Path 1037",
  d: "M158.189,503.335a.357.357,0,0,1,.271.117l.767.821a3.65,3.65,0,0,1-1.409,1.1,4.888,4.888,0,0,1-2,.375,4.757,4.757,0,0,1-1.889-.359,4.09,4.09,0,0,1-1.425-1,4.44,4.44,0,0,1-.9-1.519,5.955,5.955,0,0,1-.164-3.248,4.679,4.679,0,0,1,.441-1.16,4.485,4.485,0,0,1,.7-.957,4.223,4.223,0,0,1,.925-.727,4.433,4.433,0,0,1,1.125-.459,5.141,5.141,0,0,1,1.3-.158,5.074,5.074,0,0,1,.976.09,4.721,4.721,0,0,1,.86.252,3.943,3.943,0,0,1,.738.391,4.138,4.138,0,0,1,.609.5l-.651.892a.609.609,0,0,1-.148.149.413.413,0,0,1-.245.065.545.545,0,0,1-.313-.11q-.158-.11-.387-.246a2.807,2.807,0,0,0-.574-.246,2.927,2.927,0,0,0-.873-.11,2.668,2.668,0,0,0-1.077.213,2.339,2.339,0,0,0-.841.617,2.841,2.841,0,0,0-.545.992,4.273,4.273,0,0,0-.193,1.338,4.019,4.019,0,0,0,.21,1.348,2.96,2.96,0,0,0,.574,1,2.413,2.413,0,0,0,.851.617,2.6,2.6,0,0,0,1.041.21,5,5,0,0,0,.6-.032,2.466,2.466,0,0,0,.5-.11,2.189,2.189,0,0,0,.432-.2,2.657,2.657,0,0,0,.409-.31.793.793,0,0,1,.148-.1A.37.37,0,0,1,158.189,503.335Z",
  transform: "translate(-151.286 -496.161)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_183",
  "data-name": "Group 183",
  transform: "translate(9.308 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_182",
  "data-name": "Group 182"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_181",
  "data-name": "Group 181"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_180",
  "data-name": "Group 180"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1038",
  "data-name": "Path 1038",
  d: "M240.42,500.95a5.174,5.174,0,0,1-.345,1.907,4.4,4.4,0,0,1-2.485,2.524,5.44,5.44,0,0,1-3.919,0,4.533,4.533,0,0,1-1.515-1.005,4.44,4.44,0,0,1-.976-1.519,5.431,5.431,0,0,1,0-3.81,4.448,4.448,0,0,1,.976-1.516,4.539,4.539,0,0,1,1.515-1.005,5.441,5.441,0,0,1,3.919,0,4.419,4.419,0,0,1,2.485,2.527A5.13,5.13,0,0,1,240.42,500.95Zm-1.979,0a4.2,4.2,0,0,0-.193-1.322,2.8,2.8,0,0,0-.558-1,2.4,2.4,0,0,0-.883-.627,3.312,3.312,0,0,0-2.356,0,2.4,2.4,0,0,0-.886.627,2.8,2.8,0,0,0-.558,1,4.635,4.635,0,0,0,0,2.65,2.767,2.767,0,0,0,.558.992,2.411,2.411,0,0,0,.886.624,3.314,3.314,0,0,0,2.356,0,2.419,2.419,0,0,0,.883-.624,2.768,2.768,0,0,0,.558-.992A4.219,4.219,0,0,0,238.441,500.95Z",
  transform: "translate(-230.835 -496.161)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_187",
  "data-name": "Group 187",
  transform: "translate(21.342 0.103)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_186",
  "data-name": "Group 186"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_185",
  "data-name": "Group 185"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_184",
  "data-name": "Group 184"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1039",
  "data-name": "Path 1039",
  d: "M344,497.045v9.378h-1.708v-5.759q0-.181.01-.388t.035-.42l-2.675,5.086a.717.717,0,0,1-.677.42h-.271a.72.72,0,0,1-.677-.42l-2.688-5.106q.02.227.032.436t.013.391v5.759h-1.708v-9.378h1.47c.082,0,.155,0,.219.006a.566.566,0,0,1,.171.036.393.393,0,0,1,.135.09.714.714,0,0,1,.119.171l2.617,5q.122.226.229.465t.2.491q.1-.259.2-.5t.229-.472l2.6-4.983a.664.664,0,0,1,.122-.171.424.424,0,0,1,.139-.09.556.556,0,0,1,.168-.036c.062,0,.136-.006.222-.006Z",
  transform: "translate(-333.689 -497.045)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_191",
  "data-name": "Group 191",
  transform: "translate(34.64 0.103)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_190",
  "data-name": "Group 190"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_189",
  "data-name": "Group 189"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_188",
  "data-name": "Group 188"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1040",
  "data-name": "Path 1040",
  d: "M457.652,497.045v9.378h-1.708v-5.759q0-.181.01-.388t.035-.42l-2.675,5.086a.717.717,0,0,1-.677.42h-.271a.72.72,0,0,1-.677-.42L449,499.837q.019.227.032.436t.013.391v5.759h-1.708v-9.378h1.47c.082,0,.155,0,.219.006a.567.567,0,0,1,.171.036.394.394,0,0,1,.135.09.712.712,0,0,1,.119.171l2.617,5q.122.226.229.465t.2.491q.1-.259.2-.5t.229-.472l2.6-4.983a.665.665,0,0,1,.122-.171.426.426,0,0,1,.139-.09.557.557,0,0,1,.168-.036c.062,0,.136-.006.222-.006Z",
  transform: "translate(-447.339 -497.045)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_195",
  "data-name": "Group 195",
  transform: "translate(47.822 0.103)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_194",
  "data-name": "Group 194",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_193",
  "data-name": "Group 193"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_192",
  "data-name": "Group 192"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1041",
  "data-name": "Path 1041",
  d: "M563.944,504.872a2.144,2.144,0,0,0,.844-.158,1.734,1.734,0,0,0,.632-.449,1.971,1.971,0,0,0,.393-.7,2.989,2.989,0,0,0,.135-.931v-5.584h1.934v5.584a4.342,4.342,0,0,1-.274,1.567,3.473,3.473,0,0,1-2.021,2.039,4.8,4.8,0,0,1-3.291,0,3.466,3.466,0,0,1-2.024-2.039,4.339,4.339,0,0,1-.274-1.567v-5.584h1.934v5.584a2.985,2.985,0,0,0,.135.931,1.973,1.973,0,0,0,.393.7,1.732,1.732,0,0,0,.632.449A2.159,2.159,0,0,0,563.944,504.872Z",
  transform: "translate(-559.999 -497.045)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_199",
  "data-name": "Group 199",
  transform: "translate(58.58 0.103)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_198",
  "data-name": "Group 198"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_197",
  "data-name": "Group 197"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_196",
  "data-name": "Group 196"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1042",
  "data-name": "Path 1042",
  d: "M659.955,497.045v9.378h-1a.874.874,0,0,1-.38-.074.921.921,0,0,1-.3-.255l-4.66-5.946q.019.226.029.446t.01.407v5.423h-1.708v-9.378h1.018a1.927,1.927,0,0,1,.209.01.466.466,0,0,1,.158.045.624.624,0,0,1,.135.094,1.355,1.355,0,0,1,.142.155l4.693,5.972c-.017-.164-.03-.322-.039-.475s-.013-.3-.013-.436v-5.364Z",
  transform: "translate(-651.943 -497.045)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_203",
  "data-name": "Group 203",
  transform: "translate(69.583 0.103)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_202",
  "data-name": "Group 202"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_201",
  "data-name": "Group 201"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_200",
  "data-name": "Group 200"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1043",
  "data-name": "Path 1043",
  d: "M747.93,506.423h-1.947v-9.378h1.947Z",
  transform: "translate(-745.983 -497.045)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_207",
  "data-name": "Group 207",
  transform: "translate(73.734 0.103)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_206",
  "data-name": "Group 206"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_205",
  "data-name": "Group 205"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_204",
  "data-name": "Group 204"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1044",
  "data-name": "Path 1044",
  d: "M788.866,498.609h-2.733v7.814h-1.94v-7.814H781.46v-1.564h7.406Z",
  transform: "translate(-781.46 -497.045)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_211",
  "data-name": "Group 211",
  transform: "translate(82.236 0.103)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_210",
  "data-name": "Group 210"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_209",
  "data-name": "Group 209"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_208",
  "data-name": "Group 208"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1045",
  "data-name": "Path 1045",
  d: "M859.454,502.817v3.606H857.52v-3.606l-3.4-5.772h1.7a.632.632,0,0,1,.4.12.861.861,0,0,1,.242.307L858,500.425q.155.3.28.556t.222.517q.09-.259.209-.52t.267-.553l1.521-2.954a.962.962,0,0,1,.232-.291.583.583,0,0,1,.4-.136h1.715Z",
  transform: "translate(-854.123 -497.045)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_241",
  "data-name": "Group 241",
  transform: "translate(185.43 247.922)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_216",
  "data-name": "Group 216",
  transform: "translate(0 1.01)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_215",
  "data-name": "Group 215"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_214",
  "data-name": "Group 214"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_213",
  "data-name": "Group 213"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1046",
  "data-name": "Path 1046",
  d: "M445.98,256.551l-.322,3.312-.5.147L443.1,257.4l.441-.13a.193.193,0,0,1,.127,0,.223.223,0,0,1,.094.07l1.227,1.6q.06.078.123.174t.125.2q-.009-.122-.012-.236a1.889,1.889,0,0,1,.006-.212l.161-2.01a.2.2,0,0,1,.039-.105.188.188,0,0,1,.106-.074Z",
  transform: "translate(-443.099 -256.551)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_220",
  "data-name": "Group 220",
  transform: "translate(3.883 0.691)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_219",
  "data-name": "Group 219"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_218",
  "data-name": "Group 218"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_217",
  "data-name": "Group 217"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1047",
  "data-name": "Path 1047",
  d: "M477.473,256.846l-.563.117-.628-3.021.563-.118Z",
  transform: "translate(-476.283 -253.825)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_224",
  "data-name": "Group 224",
  transform: "translate(5.518 0.156)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_223",
  "data-name": "Group 223"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_222",
  "data-name": "Group 222"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_221",
  "data-name": "Group 221"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1048",
  "data-name": "Path 1048",
  d: "M492.731,249.726l-.92.121.339,2.592-.568.075-.339-2.592-.92.121-.061-.468,2.408-.317Z",
  transform: "translate(-490.262 -249.258)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_228",
  "data-name": "Group 228",
  transform: "translate(10.548)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_227",
  "data-name": "Group 227"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_226",
  "data-name": "Group 226"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_225",
  "data-name": "Group 225"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1049",
  "data-name": "Path 1049",
  d: "M535.893,247.968l-.054,3.085-.575-.01.024-1.349-1.445-.025-.024,1.349-.575-.01.054-3.086.575.01-.023,1.327,1.445.025.023-1.327Z",
  transform: "translate(-533.245 -247.922)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_232",
  "data-name": "Group 232",
  transform: "translate(13.889 0.269)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_231",
  "data-name": "Group 231"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_230",
  "data-name": "Group 230"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_229",
  "data-name": "Group 229"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1050",
  "data-name": "Path 1050",
  d: "M564.777,253.513l-.439-.057a.189.189,0,0,1-.115-.053.231.231,0,0,1-.058-.1l-.147-.654-1.265-.164-.308.595a.207.207,0,0,1-.077.08.184.184,0,0,1-.125.025l-.443-.057,1.6-2.9.578.075Zm-.854-1.286-.24-1.066q-.019-.071-.036-.168t-.033-.209c-.028.069-.055.135-.083.195s-.054.112-.078.157l-.5.966Z",
  transform: "translate(-561.799 -250.222)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_236",
  "data-name": "Group 236",
  transform: "translate(17.732 0.947)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_235",
  "data-name": "Group 235"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_234",
  "data-name": "Group 234"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_233",
  "data-name": "Group 233"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1051",
  "data-name": "Path 1051",
  d: "M596.743,258.568a.114.114,0,0,1,.072.055l.163.291a1.238,1.238,0,0,1-.531.24,1.585,1.585,0,0,1-.667-.032,1.548,1.548,0,0,1-.572-.257,1.361,1.361,0,0,1-.379-.426,1.429,1.429,0,0,1-.173-.555,1.879,1.879,0,0,1,.046-.641,1.767,1.767,0,0,1,.255-.594,1.463,1.463,0,0,1,.418-.412,1.408,1.408,0,0,1,.542-.205,1.588,1.588,0,0,1,.627.03,1.515,1.515,0,0,1,.555.247,1.431,1.431,0,0,1,.365.385l-.248.215a.172.172,0,0,1-.053.033.123.123,0,0,1-.076,0,.138.138,0,0,1-.06-.033c-.019-.017-.04-.037-.062-.061s-.048-.05-.077-.079a.787.787,0,0,0-.107-.086,1,1,0,0,0-.148-.081,1.121,1.121,0,0,0-.2-.067.948.948,0,0,0-.385-.016.819.819,0,0,0-.336.139.983.983,0,0,0-.265.288,1.432,1.432,0,0,0-.173.431,1.358,1.358,0,0,0-.036.468,1.017,1.017,0,0,0,.115.378.848.848,0,0,0,.239.275.913.913,0,0,0,.339.157,1.608,1.608,0,0,0,.209.037.892.892,0,0,0,.179,0,.758.758,0,0,0,.164-.034.935.935,0,0,0,.163-.072.2.2,0,0,1,.051-.02A.11.11,0,0,1,596.743,258.568Z",
  transform: "translate(-594.646 -256.012)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_240",
  "data-name": "Group 240",
  transform: "translate(20.754 1.619)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_239",
  "data-name": "Group 239"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_238",
  "data-name": "Group 238"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_237",
  "data-name": "Group 237"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1052",
  "data-name": "Path 1052",
  d: "M621.613,263.169l.126.045a.349.349,0,0,0,.134.024.225.225,0,0,0,.11-.037l1.158-.733a.308.308,0,0,1,.137-.052.358.358,0,0,1,.148.024l.466.165-1.4.864a.575.575,0,0,1-.234.094.438.438,0,0,1,.1.11.567.567,0,0,1,.061.15l.529,1.719-.476-.168a.314.314,0,0,1-.134-.078.237.237,0,0,1-.051-.107l-.443-1.365a.23.23,0,0,0-.062-.108.393.393,0,0,0-.137-.073l-.171-.06-.45,1.28-.54-.191,1.024-2.91.54.191Z",
  transform: "translate(-620.478 -261.758)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_246",
  "data-name": "Group 246",
  transform: "translate(210.445 252.39)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_245",
  "data-name": "Group 245",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_244",
  "data-name": "Group 244"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_243",
  "data-name": "Group 243"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_242",
  "data-name": "Group 242"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1053",
  "data-name": "Path 1053",
  d: "M675.137,308.894A33.117,33.117,0,0,0,660.2,288.313a32.072,32.072,0,0,0-3.3-1.764l.2-.439a32.568,32.568,0,0,1,3.353,1.791,33.6,33.6,0,0,1,15.154,20.883Z",
  transform: "translate(-656.897 -286.11)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_251",
  "data-name": "Group 251",
  transform: "translate(164.265 251.579)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_250",
  "data-name": "Group 250",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_249",
  "data-name": "Group 249"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_248",
  "data-name": "Group 248"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_247",
  "data-name": "Group 247"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1054",
  "data-name": "Path 1054",
  d: "M262.678,302.775l-.469-.111a33.429,33.429,0,0,1,20.408-23.484l.174.45a32.944,32.944,0,0,0-20.113,23.145Z",
  transform: "translate(-262.209 -279.18)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_296",
  "data-name": "Group 296",
  transform: "translate(180.305 309.379)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_255",
  "data-name": "Group 255",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_254",
  "data-name": "Group 254"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_253",
  "data-name": "Group 253"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_252",
  "data-name": "Group 252"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1055",
  "data-name": "Path 1055",
  d: "M400.947,773.8l-.379.715.9.48-.2.369-.9-.48-.387.729,1.141.609-.2.383-1.621-.865,1.367-2.577,1.621.865-.2.381Z",
  transform: "translate(-399.302 -773.166)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_259",
  "data-name": "Group 259",
  transform: "translate(2.727 1.267)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_258",
  "data-name": "Group 258"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_257",
  "data-name": "Group 257"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_256",
  "data-name": "Group 256"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1056",
  "data-name": "Path 1056",
  d: "M425.553,786.323a1.577,1.577,0,0,1-.32.506,1.319,1.319,0,0,1-1,.419,1.637,1.637,0,0,1-.6-.129l-1.028-.418,1.1-2.705,1.028.418a1.625,1.625,0,0,1,.519.328,1.365,1.365,0,0,1,.318.454,1.35,1.35,0,0,1,.105.541A1.582,1.582,0,0,1,425.553,786.323Zm-.515-.209a1.363,1.363,0,0,0,.1-.423.9.9,0,0,0-.049-.368.8.8,0,0,0-.193-.3.991.991,0,0,0-.329-.21l-.524-.213-.771,1.9.524.213a.992.992,0,0,0,.382.079.8.8,0,0,0,.345-.079.894.894,0,0,0,.291-.23A1.36,1.36,0,0,0,425.038,786.114Z",
  transform: "translate(-422.61 -783.996)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_263",
  "data-name": "Group 263",
  transform: "translate(6.247 2.511)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_262",
  "data-name": "Group 262"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_261",
  "data-name": "Group 261"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_260",
  "data-name": "Group 260"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1057",
  "data-name": "Path 1057",
  d: "M453.209,797.578l-.519-.161.862-2.789.519.161Z",
  transform: "translate(-452.69 -794.628)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_267",
  "data-name": "Group 267",
  transform: "translate(8.333 2.923)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_266",
  "data-name": "Group 266"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_265",
  "data-name": "Group 265"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_264",
  "data-name": "Group 264"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1058",
  "data-name": "Path 1058",
  d: "M472.763,799.1l-.856-.2-.552,2.411-.528-.121.552-2.411-.856-.2.1-.435,2.239.516Z",
  transform: "translate(-470.524 -798.152)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_271",
  "data-name": "Group 271",
  transform: "translate(11.064 3.564)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_270",
  "data-name": "Group 270"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_269",
  "data-name": "Group 269"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_268",
  "data-name": "Group 268"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1059",
  "data-name": "Path 1059",
  d: "M494.4,806.6l-.537-.082.439-2.886.537.082Z",
  transform: "translate(-493.86 -803.629)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_275",
  "data-name": "Group 275",
  transform: "translate(12.858 3.857)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_274",
  "data-name": "Group 274"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_273",
  "data-name": "Group 273"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_272",
  "data-name": "Group 272"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1060",
  "data-name": "Path 1060",
  d: "M512.142,807.717a1.636,1.636,0,0,1-.143.587,1.4,1.4,0,0,1-.328.453,1.356,1.356,0,0,1-.484.281,1.678,1.678,0,0,1-1.2-.077,1.367,1.367,0,0,1-.445-.341,1.4,1.4,0,0,1-.27-.492,1.709,1.709,0,0,1,.076-1.187,1.4,1.4,0,0,1,.331-.453,1.364,1.364,0,0,1,.485-.281,1.563,1.563,0,0,1,.608-.073,1.628,1.628,0,0,1,.413.078,1.461,1.461,0,0,1,.348.168,1.332,1.332,0,0,1,.278.246,1.389,1.389,0,0,1,.2.313,1.482,1.482,0,0,1,.115.367A1.717,1.717,0,0,1,512.142,807.717Zm-.553-.035a1.349,1.349,0,0,0-.037-.434.926.926,0,0,0-.162-.335.788.788,0,0,0-.275-.222,1.076,1.076,0,0,0-.766-.049.8.8,0,0,0-.3.185.919.919,0,0,0-.2.312,1.474,1.474,0,0,0-.055.86.9.9,0,0,0,.163.334.8.8,0,0,0,.276.221,1.076,1.076,0,0,0,.765.049.788.788,0,0,0,.3-.184.911.911,0,0,0,.2-.311A1.339,1.339,0,0,0,511.59,807.682Z",
  transform: "translate(-509.194 -806.13)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_279",
  "data-name": "Group 279",
  transform: "translate(16.82 3.847)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_278",
  "data-name": "Group 278"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_277",
  "data-name": "Group 277"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_276",
  "data-name": "Group 276"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1061",
  "data-name": "Path 1061",
  d: "M545.508,806.047l.154,2.915-.277.015a.242.242,0,0,1-.109-.015.249.249,0,0,1-.087-.067l-1.621-1.863c.013.088.021.17.025.245l.095,1.79-.477.025-.154-2.915.284-.015a.521.521,0,0,1,.059,0,.145.145,0,0,1,.045.01.152.152,0,0,1,.039.024.418.418,0,0,1,.043.043l1.627,1.87q-.01-.07-.017-.139c-.005-.046-.009-.088-.011-.127l-.094-1.772Z",
  transform: "translate(-543.057 -806.047)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_283",
  "data-name": "Group 283",
  transform: "translate(21.83 3.259)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_282",
  "data-name": "Group 282"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_281",
  "data-name": "Group 281"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_280",
  "data-name": "Group 280"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1062",
  "data-name": "Path 1062",
  d: "M587.947,803.321a.177.177,0,0,1,.134.019.158.158,0,0,1,.071.108l.06.292-1.956.406-.033-.162a.3.3,0,0,1,0-.108.27.27,0,0,1,.046-.112l.686-1.05q.086-.133.151-.252a1.392,1.392,0,0,0,.1-.229.963.963,0,0,0,.046-.219.76.76,0,0,0-.014-.221.521.521,0,0,0-.067-.175.371.371,0,0,0-.111-.114.354.354,0,0,0-.147-.053.522.522,0,0,0-.176.009.516.516,0,0,0-.156.058.448.448,0,0,0-.117.1.439.439,0,0,0-.075.124.459.459,0,0,0-.032.143.221.221,0,0,1-.062.139.248.248,0,0,1-.151.046l-.266.008a1.081,1.081,0,0,1,.04-.385.883.883,0,0,1,.158-.3.9.9,0,0,1,.259-.217,1.189,1.189,0,0,1,.343-.126,1.092,1.092,0,0,1,.373-.016.824.824,0,0,1,.314.107.76.76,0,0,1,.234.219.848.848,0,0,1,.134.321.913.913,0,0,1,.014.3,1.248,1.248,0,0,1-.071.283,1.746,1.746,0,0,1-.133.275q-.081.137-.171.279l-.507.792a1.5,1.5,0,0,1,.176-.081,1.135,1.135,0,0,1,.171-.051Z",
  transform: "translate(-585.878 -801.018)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_287",
  "data-name": "Group 287",
  transform: "translate(24.597 2.555)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_286",
  "data-name": "Group 286"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_285",
  "data-name": "Group 285"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_284",
  "data-name": "Group 284"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1063",
  "data-name": "Path 1063",
  d: "M611.681,796.166a2.4,2.4,0,0,1,.115.658,1.36,1.36,0,0,1-.08.511.913.913,0,0,1-.246.361,1,1,0,0,1-.379.21.994.994,0,0,1-.43.037.906.906,0,0,1-.4-.163,1.354,1.354,0,0,1-.349-.38,2.775,2.775,0,0,1-.386-1.27,1.355,1.355,0,0,1,.079-.509.91.91,0,0,1,.243-.36,1,1,0,0,1,.377-.209,1.006,1.006,0,0,1,.432-.038.913.913,0,0,1,.405.162,1.362,1.362,0,0,1,.351.378A2.391,2.391,0,0,1,611.681,796.166Zm-.491.15a2.486,2.486,0,0,0-.2-.489,1.054,1.054,0,0,0-.215-.28.45.45,0,0,0-.221-.113.469.469,0,0,0-.215.014.462.462,0,0,0-.183.108.45.45,0,0,0-.118.217,1.065,1.065,0,0,0-.02.352,3.061,3.061,0,0,0,.305,1,1.055,1.055,0,0,0,.213.281.446.446,0,0,0,.219.114.458.458,0,0,0,.212-.013.468.468,0,0,0,.186-.109.453.453,0,0,0,.12-.217,1.062,1.062,0,0,0,.022-.353A2.481,2.481,0,0,0,611.19,796.316Z",
  transform: "translate(-609.523 -795.006)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_291",
  "data-name": "Group 291",
  transform: "translate(27.308 1.57)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_290",
  "data-name": "Group 290"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_289",
  "data-name": "Group 289"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_288",
  "data-name": "Group 288"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1064",
  "data-name": "Path 1064",
  d: "M634.991,788.675a.177.177,0,0,1,.135-.006.159.159,0,0,1,.089.093l.113.277-1.849.758-.062-.153a.3.3,0,0,1-.02-.106.274.274,0,0,1,.025-.118l.483-1.158q.06-.146.1-.275a1.407,1.407,0,0,0,.058-.244.978.978,0,0,0,.006-.224.761.761,0,0,0-.054-.215.523.523,0,0,0-.1-.16.369.369,0,0,0-.13-.092.354.354,0,0,0-.154-.025.523.523,0,0,0-.172.041.513.513,0,0,0-.142.086.445.445,0,0,0-.149.252.461.461,0,0,0-.006.146.22.22,0,0,1-.036.148.247.247,0,0,1-.14.073l-.26.056a1.087,1.087,0,0,1-.031-.385.871.871,0,0,1,.316-.587,1.185,1.185,0,0,1,.314-.187,1.092,1.092,0,0,1,.364-.085.828.828,0,0,1,.328.048.762.762,0,0,1,.271.173.852.852,0,0,1,.19.291.91.91,0,0,1,.069.295,1.245,1.245,0,0,1-.018.291,1.779,1.779,0,0,1-.081.295q-.055.149-.117.305l-.354.871a1.513,1.513,0,0,1,.158-.112,1.119,1.119,0,0,1,.159-.082Z",
  transform: "translate(-632.695 -786.582)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_295",
  "data-name": "Group 295",
  transform: "translate(29.914 0.379)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_294",
  "data-name": "Group 294"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_293",
  "data-name": "Group 293"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_292",
  "data-name": "Group 292"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1065",
  "data-name": "Path 1065",
  d: "M657.126,777.349a2.388,2.388,0,0,1,.233.626,1.361,1.361,0,0,1,.014.517.914.914,0,0,1-.176.4,1.013,1.013,0,0,1-.335.276,1,1,0,0,1-.416.116.905.905,0,0,1-.425-.087,1.349,1.349,0,0,1-.413-.309A2.771,2.771,0,0,1,655,777.71a1.363,1.363,0,0,1-.015-.515.913.913,0,0,1,.173-.4,1,1,0,0,1,.333-.275,1.01,1.01,0,0,1,.417-.116.911.911,0,0,1,.428.085,1.356,1.356,0,0,1,.414.308A2.388,2.388,0,0,1,657.126,777.349Zm-.456.238a2.462,2.462,0,0,0-.283-.444,1.057,1.057,0,0,0-.262-.237.454.454,0,0,0-.238-.071.47.47,0,0,0-.208.053.46.46,0,0,0-.16.139.449.449,0,0,0-.077.235,1.065,1.065,0,0,0,.044.35,3.06,3.06,0,0,0,.483.932,1.053,1.053,0,0,0,.261.237.445.445,0,0,0,.236.072.458.458,0,0,0,.206-.052.473.473,0,0,0,.163-.141.457.457,0,0,0,.079-.236,1.063,1.063,0,0,0-.043-.351A2.474,2.474,0,0,0,656.671,777.586Z",
  transform: "translate(-654.965 -776.403)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_301",
  "data-name": "Group 301",
  transform: "translate(213.595 288.131)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_300",
  "data-name": "Group 300"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_299",
  "data-name": "Group 299"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_298",
  "data-name": "Group 298"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_297",
  "data-name": "Group 297"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1066",
  "data-name": "Path 1066",
  d: "M684.07,613.7l-.255-.409a31.964,31.964,0,0,0,14.524-21.717l.475.08A32.445,32.445,0,0,1,684.07,613.7Z",
  transform: "translate(-683.814 -591.575)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_306",
  "data-name": "Group 306",
  transform: "translate(164.826 288.131)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_305",
  "data-name": "Group 305"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_304",
  "data-name": "Group 304"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_303",
  "data-name": "Group 303"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_302",
  "data-name": "Group 302"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1067",
  "data-name": "Path 1067",
  d: "M281.393,613.473a32.5,32.5,0,0,1-14.388-21.819l.475-.081a32.014,32.014,0,0,0,14.174,21.494Z",
  transform: "translate(-267.005 -591.573)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_311",
  "data-name": "Group 311",
  transform: "translate(168.082 288.021)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_310",
  "data-name": "Group 310"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_309",
  "data-name": "Group 309"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_308",
  "data-name": "Group 308"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_307",
  "data-name": "Group 307"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1068",
  "data-name": "Path 1068",
  d: "M323.458,614.082a29.25,29.25,0,0,1-28.626-23.4l.236-.048a28.97,28.97,0,0,0,56.781,0l.236.048a29.247,29.247,0,0,1-28.626,23.4Z",
  transform: "translate(-294.832 -590.634)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_316",
  "data-name": "Group 316",
  transform: "translate(168.349 252.871)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_315",
  "data-name": "Group 315",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_314",
  "data-name": "Group 314"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_313",
  "data-name": "Group 313"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_312",
  "data-name": "Group 312"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1069",
  "data-name": "Path 1069",
  d: "M297.354,312.494l-.234-.058a29.451,29.451,0,0,1,10.225-15.9,29.163,29.163,0,0,1,36.269,0,29.44,29.44,0,0,1,10.223,15.9l-.234.058a28.966,28.966,0,0,0-56.25,0Z",
  transform: "translate(-297.12 -290.217)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1066",
  "data-name": "Group 1066",
  transform: "translate(178.119 289.581)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_325",
  "data-name": "Group 325",
  transform: "translate(19.261 13.323)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_320",
  "data-name": "Group 320",
  transform: "translate(0.005 0.08)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_319",
  "data-name": "Group 319"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_318",
  "data-name": "Group 318"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_317",
  "data-name": "Group 317"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1070",
  "data-name": "Path 1070",
  d: "M545.614,718.534l.036,0,.228-.014c-.188.013-.382.023-.578.028l-.03,0C545.385,718.545,545.5,718.54,545.614,718.534Z",
  transform: "translate(-545.269 -718.518)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_324",
  "data-name": "Group 324"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_323",
  "data-name": "Group 323"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_322",
  "data-name": "Group 322"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_321",
  "data-name": "Group 321"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1071",
  "data-name": "Path 1071",
  d: "M545.234,718.023l-.008-.161.026,0c.126,0,.248-.009.368-.016l.215-.013.01.161-.217.013-.048,0Q545.409,718.018,545.234,718.023Z",
  transform: "translate(-545.227 -717.832)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_334",
  "data-name": "Group 334",
  transform: "translate(17.008 13.294)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_329",
  "data-name": "Group 329",
  transform: "translate(0.007 0.08)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_328",
  "data-name": "Group 328"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_327",
  "data-name": "Group 327"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_326",
  "data-name": "Group 326"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1072",
  "data-name": "Path 1072",
  d: "M526.033,718.267l.206.017-.035,0Z",
  transform: "translate(-526.033 -718.267)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_333",
  "data-name": "Group 333"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_332",
  "data-name": "Group 332"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_331",
  "data-name": "Group 331"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_330",
  "data-name": "Group 330"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1073",
  "data-name": "Path 1073",
  d: "M526.184,717.759l-.207-.017.013-.16.206.017Z",
  transform: "translate(-525.977 -717.582)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_343",
  "data-name": "Group 343",
  transform: "translate(18.328 13.352)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_338",
  "data-name": "Group 338",
  transform: "translate(0.254 0.08)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_337",
  "data-name": "Group 337"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_336",
  "data-name": "Group 336"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_335",
  "data-name": "Group 335"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1074",
  "data-name": "Path 1074",
  d: "M539.436,718.778l-.005,0c.222,0,.445,0,.665-.01l.03,0C539.9,718.775,539.667,718.779,539.436,718.778Z",
  transform: "translate(-539.431 -718.768)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_342",
  "data-name": "Group 342"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_341",
  "data-name": "Group 341"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_340",
  "data-name": "Group 340"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_339",
  "data-name": "Group 339"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1075",
  "data-name": "Path 1075",
  d: "M537.545,718.253h-.286l.235-.163h.024c.231,0,.462,0,.687-.01l.008.161-.031,0C537.982,718.25,537.768,718.253,537.545,718.253Z",
  transform: "translate(-537.259 -718.08)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_352",
  "data-name": "Group 352",
  transform: "translate(17.194 13.309)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_347",
  "data-name": "Group 347",
  transform: "translate(0.01 0.08)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_346",
  "data-name": "Group 346"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_345",
  "data-name": "Group 345"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_344",
  "data-name": "Group 344"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1076",
  "data-name": "Path 1076",
  d: "M527.646,718.4l.038,0,.037,0c.195.014.4.025.6.033l-.021,0C528.079,718.425,527.858,718.413,527.646,718.4Z",
  transform: "translate(-527.646 -718.396)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_351",
  "data-name": "Group 351"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_350",
  "data-name": "Group 350"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_349",
  "data-name": "Group 349"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_348",
  "data-name": "Group 348"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1077",
  "data-name": "Path 1077",
  d: "M528.249,717.912c-.208-.008-.411-.019-.607-.033l-.076-.007h0l.016-.16c.2.016.425.029.655.038h.021l-.008.139Z",
  transform: "translate(-527.563 -717.711)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_361",
  "data-name": "Group 361",
  transform: "translate(17.878 13.347)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_356",
  "data-name": "Group 356",
  transform: "translate(0.003 0.081)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_355",
  "data-name": "Group 355"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_354",
  "data-name": "Group 354"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_353",
  "data-name": "Group 353"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1078",
  "data-name": "Path 1078",
  d: "M533.436,718.728l.02,0c.218.009.44.013.662.014h0C533.892,718.742,533.662,718.737,533.436,718.728Z",
  transform: "translate(-533.436 -718.728)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_360",
  "data-name": "Group 360"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_359",
  "data-name": "Group 359"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_358",
  "data-name": "Group 358"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_357",
  "data-name": "Group 357"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1079",
  "data-name": "Path 1079",
  d: "M534.1,718.216c-.236,0-.46,0-.674-.013v0h-.02l.009-.128,0-.033c.229.009.46.014.684.014h.233l-.2.157Zm-.685-.144-.006.048.007-.031Z",
  transform: "translate(-533.409 -718.04)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_370",
  "data-name": "Group 370",
  transform: "translate(21.504 12.506)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_365",
  "data-name": "Group 365",
  transform: "translate(0.32 0.146)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_364",
  "data-name": "Group 364"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_363",
  "data-name": "Group 363"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_362",
  "data-name": "Group 362"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1080",
  "data-name": "Path 1080",
  d: "M567.563,712.207l-.379.031-.049.029.373-.031c.339-.03.654-.064.943-.1l.07-.031Q568.079,712.161,567.563,712.207Z",
  transform: "translate(-567.135 -712.104)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_369",
  "data-name": "Group 369"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_368",
  "data-name": "Group 368"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_367",
  "data-name": "Group 367"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_366",
  "data-name": "Group 366"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1081",
  "data-name": "Path 1081",
  d: "M564.4,711.269l.344-.215.019,0,.356-.029.023,0c.34-.03.661-.065.954-.1l.514-.067-.469.219-.072.032-.021.006c-.291.038-.61.072-.947.1l-.325.027Z",
  transform: "translate(-564.399 -710.852)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_379",
  "data-name": "Group 379",
  transform: "translate(20.119 12.685)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_374",
  "data-name": "Group 374",
  transform: "translate(0.2 0.105)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_373",
  "data-name": "Group 373"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_372",
  "data-name": "Group 372"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_371",
  "data-name": "Group 371"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1082",
  "data-name": "Path 1082",
  d: "M554.3,713.355l-.027.027c.5-.016.991-.042,1.464-.077l.049-.029C555.308,713.312,554.81,713.338,554.3,713.355Z",
  transform: "translate(-554.275 -713.276)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_378",
  "data-name": "Group 378"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_377",
  "data-name": "Group 377"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_376",
  "data-name": "Group 376"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_375",
  "data-name": "Group 375"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1083",
  "data-name": "Path 1083",
  d: "M552.564,712.679l.193-.194h.032c.519-.017,1.018-.044,1.482-.079l.323-.024-.341.213-.02,0c-.457.034-.95.06-1.467.077Z",
  transform: "translate(-552.564 -712.381)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_388",
  "data-name": "Group 388",
  transform: "translate(15.413 12.673)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_383",
  "data-name": "Group 383",
  transform: "translate(0.261 0.101)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_382",
  "data-name": "Group 382"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_381",
  "data-name": "Group 381"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_380",
  "data-name": "Group 380"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1084",
  "data-name": "Path 1084",
  d: "M516.041,713.219c-.5-.02-1-.048-1.47-.084l.04.03c.467.035.952.063,1.448.083Z",
  transform: "translate(-514.571 -713.135)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_387",
  "data-name": "Group 387"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_386",
  "data-name": "Group 386"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_385",
  "data-name": "Group 385"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_384",
  "data-name": "Group 384"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1085",
  "data-name": "Path 1085",
  d: "M514.241,712.573l-.152,0c-.486-.019-.974-.047-1.451-.083l-.024,0-.271-.209.267.02c.486.037.979.065,1.467.084l.039,0,.023.032.02.03Z",
  transform: "translate(-512.343 -712.275)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_397",
  "data-name": "Group 397",
  transform: "translate(18.667 12.783)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_392",
  "data-name": "Group 392",
  transform: "translate(0.092 0.087)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_391",
  "data-name": "Group 391"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_390",
  "data-name": "Group 390"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_389",
  "data-name": "Group 389"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1086",
  "data-name": "Path 1086",
  d: "M542.49,713.959c-.507.017-1.023.024-1.539.023,0,.009,0,.018,0,.027.508,0,1.017-.005,1.516-.021Z",
  transform: "translate(-540.947 -713.959)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_396",
  "data-name": "Group 396"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_395",
  "data-name": "Group 395"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_394",
  "data-name": "Group 394"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_393",
  "data-name": "Group 393"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1087",
  "data-name": "Path 1087",
  d: "M540.416,713.435h-.258l.027-.174.07-.013c.533,0,1.05-.006,1.536-.023l.189-.006-.127.141c-.011.011-.02.022-.032.033l-.022.021h-.03C541.318,713.428,540.863,713.435,540.416,713.435Z",
  transform: "translate(-540.158 -713.218)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_406",
  "data-name": "Group 406",
  transform: "translate(11.824 12.056)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_401",
  "data-name": "Group 401",
  transform: "translate(0.03 0.075)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_400",
  "data-name": "Group 400"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_399",
  "data-name": "Group 399"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_398",
  "data-name": "Group 398"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1088",
  "data-name": "Path 1088",
  d: "M481.92,707.647l.12.048c.07.027.147.053.23.079l-.092-.037C482.084,707.707,482,707.677,481.92,707.647Z",
  transform: "translate(-481.92 -707.647)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_405",
  "data-name": "Group 405"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_404",
  "data-name": "Group 404"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_403",
  "data-name": "Group 403"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_402",
  "data-name": "Group 402"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1089",
  "data-name": "Path 1089",
  d: "M482.023,707.285c-.085-.026-.164-.053-.235-.081l-.121-.048.059-.15c.076.03.16.059.253.087l.1.039Z",
  transform: "translate(-481.667 -707.007)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_415",
  "data-name": "Group 415",
  transform: "translate(12.102 12.15)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_410",
  "data-name": "Group 410",
  transform: "translate(0.031 0.077)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_409",
  "data-name": "Group 409"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_408",
  "data-name": "Group 408"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_407",
  "data-name": "Group 407"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1090",
  "data-name": "Path 1090",
  d: "M484.569,708.541c-.092-.024-.178-.048-.258-.073l.092.037q.117.036.254.072.3.078.654.146l-.079-.033C484.992,708.643,484.769,708.593,484.569,708.541Z",
  transform: "translate(-484.311 -708.468)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_414",
  "data-name": "Group 414"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_413",
  "data-name": "Group 413"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_412",
  "data-name": "Group 412"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_411",
  "data-name": "Group 411"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1091",
  "data-name": "Path 1091",
  d: "M485.062,708.221c-.242-.046-.464-.1-.66-.147q-.138-.036-.257-.072l-.1-.04.055-.151c.079.024.163.049.254.072h0c.194.051.416.1.658.147l.048.019.045.019Z",
  transform: "translate(-484.046 -707.81)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_424",
  "data-name": "Group 424",
  transform: "translate(17.017 12.773)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_419",
  "data-name": "Group 419",
  transform: "translate(0.17 0.087)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_418",
  "data-name": "Group 418"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_417",
  "data-name": "Group 417"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_416",
  "data-name": "Group 416"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1092",
  "data-name": "Path 1092",
  d: "M529.034,713.9c-.515,0-1.03-.013-1.534-.032a.32.32,0,0,1,.019.028c.5.019,1,.03,1.511.032C529.031,713.923,529.033,713.915,529.034,713.9Z",
  transform: "translate(-527.5 -713.873)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_423",
  "data-name": "Group 423"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_422",
  "data-name": "Group 422"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_421",
  "data-name": "Group 421"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_420",
  "data-name": "Group 420"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1093",
  "data-name": "Path 1093",
  d: "M527.75,713.357c-.5,0-1.009-.013-1.514-.032l-.043,0-.023-.036a.225.225,0,0,0-.014-.021l-.106-.136.172.006c.529.019,1.044.03,1.532.032h.09l-.025.177Z",
  transform: "translate(-526.051 -713.13)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_433",
  "data-name": "Group 433",
  transform: "translate(24.206 12.187)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_428",
  "data-name": "Group 428",
  transform: "translate(0.028 0.076)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_427",
  "data-name": "Group 427"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_426",
  "data-name": "Group 426"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_425",
  "data-name": "Group 425"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1094",
  "data-name": "Path 1094",
  d: "M588.45,708.816l.114-.042a5.671,5.671,0,0,1-.744.206l-.086.033A5.542,5.542,0,0,0,588.45,708.816Z",
  transform: "translate(-587.734 -708.774)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_432",
  "data-name": "Group 432"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_431",
  "data-name": "Group 431"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_430",
  "data-name": "Group 430"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_429",
  "data-name": "Group 429"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1095",
  "data-name": "Path 1095",
  d: "M587.537,708.521l-.045-.154.086-.033a5.811,5.811,0,0,0,.745-.206l.056.151-.115.043A5.693,5.693,0,0,1,587.537,708.521Z",
  transform: "translate(-587.492 -708.128)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_442",
  "data-name": "Group 442",
  transform: "translate(12.47 12.256)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_437",
  "data-name": "Group 437",
  transform: "translate(0.614 0.198)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_436",
  "data-name": "Group 436"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_435",
  "data-name": "Group 435"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_434",
  "data-name": "Group 434"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1096",
  "data-name": "Path 1096",
  d: "M492.446,710.407l.077.034c.348.066.734.124,1.149.176l-.061-.031C493.19,710.534,492.8,710.474,492.446,710.407Z",
  transform: "translate(-492.446 -710.407)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_441",
  "data-name": "Group 441"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_440",
  "data-name": "Group 440"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_439",
  "data-name": "Group 439"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_438",
  "data-name": "Group 438"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1097",
  "data-name": "Path 1097",
  d: "M489.493,709.259l-.467-.058c-.424-.053-.813-.112-1.154-.177l-.019-.006-.077-.034-.581-.271.629.119c.349.066.739.126,1.16.178l.025.008Z",
  transform: "translate(-487.195 -708.713)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_451",
  "data-name": "Group 451",
  transform: "translate(22.631 12.395)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_446",
  "data-name": "Group 446",
  transform: "translate(0.543 0.079)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_445",
  "data-name": "Group 445"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_444",
  "data-name": "Group 444"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_443",
  "data-name": "Group 443"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1098",
  "data-name": "Path 1098",
  d: "M578.745,710.747l-.07.031q.588-.078,1.035-.172l.086-.034C579.494,710.636,579.143,710.7,578.745,710.747Z",
  transform: "translate(-578.675 -710.572)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_450",
  "data-name": "Group 450"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_449",
  "data-name": "Group 449"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_448",
  "data-name": "Group 448"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_447",
  "data-name": "Group 447"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1099",
  "data-name": "Path 1099",
  d: "M574.033,710.336l.526-.233.052-.024.024-.007c.384-.05.735-.108,1.045-.174l.047.153-.086.034c-.316.068-.666.126-1.054.177Z",
  transform: "translate(-574.033 -709.899)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_460",
  "data-name": "Group 460",
  transform: "translate(13.891 12.507)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_455",
  "data-name": "Group 455",
  transform: "translate(0.395 0.13)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_454",
  "data-name": "Group 454"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_453",
  "data-name": "Group 453"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_452",
  "data-name": "Group 452"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1100",
  "data-name": "Path 1100",
  d: "M502.716,711.972l.06.032c.416.051.862.095,1.327.13l-.04-.029C503.591,712.068,503.139,712.024,502.716,711.972Z",
  transform: "translate(-502.716 -711.972)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_459",
  "data-name": "Group 459"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_458",
  "data-name": "Group 458"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_457",
  "data-name": "Group 457"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_456",
  "data-name": "Group 456"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1101",
  "data-name": "Path 1101",
  d: "M501.4,711.256l-.284-.021c-.47-.036-.918-.08-1.331-.131l-.028-.009-.062-.033-.356-.2.405.05c.411.051.863.1,1.344.133l.022,0Z",
  transform: "translate(-499.336 -710.862)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_469",
  "data-name": "Group 469",
  transform: "translate(26.805 10.246)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_464",
  "data-name": "Group 464",
  transform: "translate(0.337 0.274)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_463",
  "data-name": "Group 463"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_462",
  "data-name": "Group 462"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_461",
  "data-name": "Group 461"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1102",
  "data-name": "Path 1102",
  d: "M612.667,694.188l-.075.057a8.383,8.383,0,0,0,1.1-.305c.028-.02.057-.038.084-.059A8.254,8.254,0,0,1,612.667,694.188Z",
  transform: "translate(-612.592 -693.881)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_468",
  "data-name": "Group 468"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_467",
  "data-name": "Group 467"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_466",
  "data-name": "Group 466"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_465",
  "data-name": "Group 465"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1103",
  "data-name": "Path 1103",
  d: "M609.71,692.329l.4-.291a8.163,8.163,0,0,0,1.1-.3l.538-.2-.463.339-.065.046-.039.023a8.483,8.483,0,0,1-1.114.308Z",
  transform: "translate(-609.71 -691.535)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_478",
  "data-name": "Group 478",
  transform: "translate(8.101 10.032)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_473",
  "data-name": "Group 473",
  transform: "translate(0.045 0.069)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_472",
  "data-name": "Group 472"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_471",
  "data-name": "Group 471"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_470",
  "data-name": "Group 470"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1104",
  "data-name": "Path 1104",
  d: "M450.234,690.292l.087.062a3.947,3.947,0,0,0,.851.356l-.08-.059A4,4,0,0,1,450.234,690.292Z",
  transform: "translate(-450.234 -690.292)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_477",
  "data-name": "Group 477"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_476",
  "data-name": "Group 476"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_475",
  "data-name": "Group 475"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_474",
  "data-name": "Group 474"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1105",
  "data-name": "Path 1105",
  d: "M451.24,690.4l-.43-.135a4.051,4.051,0,0,1-.869-.364l-.018-.012-.073-.051.086-.136a3.938,3.938,0,0,0,.841.35l.024.012Z",
  transform: "translate(-449.851 -689.704)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_487",
  "data-name": "Group 487",
  transform: "translate(14.165 11.191)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_482",
  "data-name": "Group 482",
  transform: "translate(0.154 0.092)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_481",
  "data-name": "Group 481"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_480",
  "data-name": "Group 480"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_479",
  "data-name": "Group 479"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1106",
  "data-name": "Path 1106",
  d: "M505.19,700.528c-.751-.029-1.487-.071-2.193-.125l.034.052c.7.053,1.429.095,2.174.124Z",
  transform: "translate(-502.997 -700.403)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_486",
  "data-name": "Group 486"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_485",
  "data-name": "Group 485"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_484",
  "data-name": "Group 484"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_483",
  "data-name": "Group 483"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1107",
  "data-name": "Path 1107",
  d: "M504.039,699.963c-.749-.03-1.481-.071-2.177-.124l-.039,0-.144-.221.16.012c.715.054,1.452.1,2.19.125l.057,0,.065.207Z",
  transform: "translate(-501.679 -699.614)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_496",
  "data-name": "Group 496",
  transform: "translate(25.301 10.685)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_491",
  "data-name": "Group 491",
  transform: "translate(0.25 0.151)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_490",
  "data-name": "Group 490"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_489",
  "data-name": "Group 489"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_488",
  "data-name": "Group 488"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1108",
  "data-name": "Path 1108",
  d: "M600.62,696.578c-.45.095-.973.183-1.567.261l-.061.053c.589-.076,1.108-.164,1.553-.258Z",
  transform: "translate(-598.992 -696.578)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_495",
  "data-name": "Group 495"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_494",
  "data-name": "Group 494"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_493",
  "data-name": "Group 493"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_492",
  "data-name": "Group 492"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1109",
  "data-name": "Path 1109",
  d: "M596.856,695.865l.277-.243.023,0c.582-.077,1.107-.164,1.561-.26l.342-.072-.276.215-.061.046-.046.025c-.459.1-.984.185-1.56.26Z",
  transform: "translate(-596.856 -695.286)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_505",
  "data-name": "Group 505",
  transform: "translate(8.01 9.976)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_500",
  "data-name": "Group 500",
  transform: "translate(0.047 0.066)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_499",
  "data-name": "Group 499"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_498",
  "data-name": "Group 498"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_497",
  "data-name": "Group 497"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1110",
  "data-name": "Path 1110",
  d: "M449.472,689.788l.094.067.066.043-.087-.062Z",
  transform: "translate(-449.472 -689.788)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_504",
  "data-name": "Group 504"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_503",
  "data-name": "Group 503"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_502",
  "data-name": "Group 502"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_501",
  "data-name": "Group 501"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1111",
  "data-name": "Path 1111",
  d: "M449.238,689.471l-.063-.041-.095-.067-.006,0h0l.093-.131h0l0,0,.066.044.09.064Z",
  transform: "translate(-449.074 -689.227)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_514",
  "data-name": "Group 514",
  transform: "translate(12.032 10.973)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_509",
  "data-name": "Group 509",
  transform: "translate(0.218 0.108)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_508",
  "data-name": "Group 508"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_507",
  "data-name": "Group 507"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_506",
  "data-name": "Group 506"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1112",
  "data-name": "Path 1112",
  d: "M487.318,698.869c-.7-.054-1.379-.121-2.009-.2l.052.054c.625.076,1.295.142,1.992.2Z",
  transform: "translate(-485.309 -698.671)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_513",
  "data-name": "Group 513"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_512",
  "data-name": "Group 512"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_511",
  "data-name": "Group 511"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_510",
  "data-name": "Group 510"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1113",
  "data-name": "Path 1113",
  d: "M485.869,698.2l-.166-.013c-.7-.054-1.371-.121-2-.2l-.028,0-.232-.238.228.028c.636.077,1.31.144,2.005.2l.039,0Z",
  transform: "translate(-483.447 -697.752)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_523",
  "data-name": "Group 523",
  transform: "translate(8.596 10.251)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_518",
  "data-name": "Group 518",
  transform: "translate(0.44 0.218)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_517",
  "data-name": "Group 517"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_516",
  "data-name": "Group 516"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_515",
  "data-name": "Group 515"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1114",
  "data-name": "Path 1114",
  d: "M459.291,693.823l-.067-.056c-.359-.068-.691-.143-.991-.221q-.2-.054-.384-.109l.08.059c.119.037.245.073.381.108C458.607,693.681,458.935,693.755,459.291,693.823Z",
  transform: "translate(-457.849 -693.437)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_522",
  "data-name": "Group 522"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_521",
  "data-name": "Group 521"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_520",
  "data-name": "Group 520"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_519",
  "data-name": "Group 519"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1115",
  "data-name": "Path 1115",
  d: "M456.267,692.32l-.315-.06c-.348-.067-.68-.141-.987-.22-.137-.036-.265-.072-.385-.109l-.024-.012-.472-.341.464.141q.178.054.382.108c.3.079.634.153.985.22l.021,0,.016.014.065.055Z",
  transform: "translate(-454.085 -691.578)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_532",
  "data-name": "Group 532",
  transform: "translate(16.472 11.327)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_527",
  "data-name": "Group 527",
  transform: "translate(0.105 0.085)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_526",
  "data-name": "Group 526"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_525",
  "data-name": "Group 525"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_524",
  "data-name": "Group 524"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1116",
  "data-name": "Path 1116",
  d: "M524.575,701.542c-.769,0-1.536-.019-2.288-.048,0,.018.01.034.015.051.746.028,1.507.045,2.269.048C524.572,701.577,524.573,701.56,524.575,701.542Z",
  transform: "translate(-522.287 -701.494)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_531",
  "data-name": "Group 531"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_530",
  "data-name": "Group 530"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_529",
  "data-name": "Group 529"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_528",
  "data-name": "Group 528"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1117",
  "data-name": "Path 1117",
  d: "M523.858,701.036h-.076c-.743,0-1.507-.019-2.272-.048l-.056,0-.017-.054c-.006-.018-.011-.036-.016-.055l-.027-.1.108,0c.742.029,1.51.045,2.285.048h.088l-.008.088c0,.017,0,.032,0,.048Z",
  transform: "translate(-521.393 -700.771)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_541",
  "data-name": "Group 541",
  transform: "translate(10.179 10.672)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_536",
  "data-name": "Group 536",
  transform: "translate(0.277 0.135)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_535",
  "data-name": "Group 535"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_534",
  "data-name": "Group 534"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_533",
  "data-name": "Group 533"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1118",
  "data-name": "Path 1118",
  d: "M471.72,696.594c-.629-.078-1.213-.167-1.739-.267l.067.056c.522.1,1.1.187,1.725.265Z",
  transform: "translate(-469.981 -696.327)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_540",
  "data-name": "Group 540"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_539",
  "data-name": "Group 539"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_538",
  "data-name": "Group 538"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_537",
  "data-name": "Group 537"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1119",
  "data-name": "Path 1119",
  d: "M469.894,695.733l-.223-.021c-.64-.08-1.222-.169-1.73-.266l-.02,0-.03-.025-.055-.046-.225-.2.292.055c.523.1,1.107.189,1.734.266l.029,0Z",
  transform: "translate(-467.611 -695.176)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_550",
  "data-name": "Group 550",
  transform: "translate(23.338 10.991)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_545",
  "data-name": "Group 545",
  transform: "translate(0.186 0.113)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_544",
  "data-name": "Group 544"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_543",
  "data-name": "Group 543"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_542",
  "data-name": "Group 542"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1120",
  "data-name": "Path 1120",
  d: "M583.642,698.918l.06-.053q-.658.085-1.429.153c-.186.016-.374.032-.564.046l-.044.052c.189-.014.375-.029.56-.046Q582.989,699,583.642,698.918Z",
  transform: "translate(-581.665 -698.865)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_549",
  "data-name": "Group 549"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_548",
  "data-name": "Group 548"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_547",
  "data-name": "Group 547"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_546",
  "data-name": "Group 546"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1121",
  "data-name": "Path 1121",
  d: "M580.076,698.359l.191-.224.033,0c.19-.014.378-.03.564-.046.495-.044.974-.1,1.425-.153l.257-.033-.273.243-.025,0c-.442.057-.919.109-1.42.153-.185.017-.372.031-.561.046Z",
  transform: "translate(-580.076 -697.9)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_559",
  "data-name": "Group 559",
  transform: "translate(18.837 11.343)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_554",
  "data-name": "Group 554",
  transform: "translate(0.089 0.085)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_553",
  "data-name": "Group 553"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_552",
  "data-name": "Group 552"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_551",
  "data-name": "Group 551"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1122",
  "data-name": "Path 1122",
  d: "M544.664,701.632c-.757.025-1.527.035-2.3.032,0,.018,0,.034,0,.051.762,0,1.526-.008,2.277-.033C544.648,701.666,544.656,701.65,544.664,701.632Z",
  transform: "translate(-542.364 -701.632)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_558",
  "data-name": "Group 558"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_557",
  "data-name": "Group 557"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_556",
  "data-name": "Group 556"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_555",
  "data-name": "Group 555"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1123",
  "data-name": "Path 1123",
  d: "M541.9,701.157h-.3l.021-.212h.073c.777,0,1.549-.008,2.293-.032l.129,0-.1.214-.051,0C543.3,701.146,542.607,701.157,541.9,701.157Z",
  transform: "translate(-541.605 -700.908)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_568",
  "data-name": "Group 568",
  transform: "translate(21.133 11.214)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_563",
  "data-name": "Group 563",
  transform: "translate(0.133 0.095)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_562",
  "data-name": "Group 562"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_561",
  "data-name": "Group 561"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_560",
  "data-name": "Group 560"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1124",
  "data-name": "Path 1124",
  d: "M564.608,700.614c-.716.053-1.46.092-2.217.117-.008.017-.016.035-.024.051.75-.025,1.487-.063,2.2-.116Z",
  transform: "translate(-562.367 -700.614)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_567",
  "data-name": "Group 567"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_566",
  "data-name": "Group 566"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_565",
  "data-name": "Group 565"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_564",
  "data-name": "Group 564"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1125",
  "data-name": "Path 1125",
  d: "M561.228,700.152l.106-.214.049,0c.765-.025,1.51-.064,2.213-.117l.192-.014-.19.224-.033,0c-.707.052-1.448.092-2.2.116Z",
  transform: "translate(-561.228 -699.805)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_577",
  "data-name": "Group 577",
  transform: "translate(31.828 7.468)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_572",
  "data-name": "Group 572",
  transform: "translate(0.058 0.055)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_571",
  "data-name": "Group 571"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_570",
  "data-name": "Group 570"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_569",
  "data-name": "Group 569"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1126",
  "data-name": "Path 1126",
  d: "M653.183,668.347h0l.078-.084c-.017.019-.036.038-.057.057l-.074.08C653.149,668.381,653.167,668.364,653.183,668.347Z",
  transform: "translate(-653.13 -668.262)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_576",
  "data-name": "Group 576"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_575",
  "data-name": "Group 575"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_574",
  "data-name": "Group 574"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_573",
  "data-name": "Group 573"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1127",
  "data-name": "Path 1127",
  d: "M652.748,668.047l-.112-.115.051-.054.023-.025c.02-.019.036-.034.05-.049l.007-.008.118.109-.008.008-.07.077C652.789,668.009,652.769,668.028,652.748,668.047Z",
  transform: "translate(-652.636 -667.796)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_586",
  "data-name": "Group 586",
  transform: "translate(4.848 7.139)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_581",
  "data-name": "Group 581",
  transform: "translate(0.44 0.362)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_580",
  "data-name": "Group 580"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_579",
  "data-name": "Group 579"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_578",
  "data-name": "Group 578"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1128",
  "data-name": "Path 1128",
  d: "M426.909,668.538a5.088,5.088,0,0,1-1.1-.458l.071.08a4.993,4.993,0,0,0,1.092.455Z",
  transform: "translate(-425.811 -668.08)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_585",
  "data-name": "Group 585"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_584",
  "data-name": "Group 584"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_583",
  "data-name": "Group 583"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_582",
  "data-name": "Group 582"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1129",
  "data-name": "Path 1129",
  d: "M423.9,666.043l-.27-.084a5.093,5.093,0,0,1-1.11-.463l-.018-.015-.071-.079-.38-.417.481.294a5.029,5.029,0,0,0,1.08.45l.023.007.015.018.064.076Z",
  transform: "translate(-422.052 -664.984)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_595",
  "data-name": "Group 595",
  transform: "translate(21.971 8.955)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_590",
  "data-name": "Group 590",
  transform: "translate(0.106 0.091)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_589",
  "data-name": "Group 589"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_588",
  "data-name": "Group 588"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_587",
  "data-name": "Group 587"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1130",
  "data-name": "Path 1130",
  d: "M572.149,681.281c-.916.068-1.867.118-2.834.15l-.02.072c.962-.032,1.907-.082,2.818-.149Z",
  transform: "translate(-569.295 -681.281)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_594",
  "data-name": "Group 594"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_593",
  "data-name": "Group 593"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_592",
  "data-name": "Group 592"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_591",
  "data-name": "Group 591"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1131",
  "data-name": "Path 1131",
  d: "M568.391,680.9l.064-.234.059,0c.971-.032,1.924-.083,2.831-.15l.141-.01-.119.24-.046,0c-.888.066-1.837.116-2.822.15Z",
  transform: "translate(-568.391 -680.506)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_604",
  "data-name": "Group 604",
  transform: "translate(6.189 7.815)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_599",
  "data-name": "Group 599",
  transform: "translate(0.238 0.157)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_598",
  "data-name": "Group 598"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_597",
  "data-name": "Group 597"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_596",
  "data-name": "Group 596"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1132",
  "data-name": "Path 1132",
  d: "M437.36,672.6l-.055-.076c-.459-.088-.883-.182-1.266-.283q-.263-.069-.492-.139l.065.078c.152.047.315.093.489.139C436.482,672.418,436.9,672.512,437.36,672.6Z",
  transform: "translate(-435.547 -672.102)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_603",
  "data-name": "Group 603"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_602",
  "data-name": "Group 602"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_601",
  "data-name": "Group 601"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_600",
  "data-name": "Group 600"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1133",
  "data-name": "Path 1133",
  d: "M435.747,671.531l-.2-.038c-.467-.09-.892-.185-1.265-.282-.179-.047-.344-.094-.492-.14l-.022-.007-.257-.305.261.08c.152.047.315.092.489.138.367.1.791.191,1.261.281l.031.006Z",
  transform: "translate(-433.513 -670.759)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_613",
  "data-name": "Group 613",
  transform: "translate(30.792 7.532)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_608",
  "data-name": "Group 608",
  transform: "translate(0.269 0.06)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_607",
  "data-name": "Group 607"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_606",
  "data-name": "Group 606"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_605",
  "data-name": "Group 605"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1134",
  "data-name": "Path 1134",
  d: "M646.153,669.291l-.069.078a2.684,2.684,0,0,0,.81-.432l.073-.08A2.693,2.693,0,0,1,646.153,669.291Z",
  transform: "translate(-646.084 -668.857)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_612",
  "data-name": "Group 612"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_611",
  "data-name": "Group 611"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_610",
  "data-name": "Group 610"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_609",
  "data-name": "Group 609"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1135",
  "data-name": "Path 1135",
  d: "M643.781,669.1l.292-.333.019-.007a2.624,2.624,0,0,0,.79-.42l.113.114-.068.075-.012.012a2.754,2.754,0,0,1-.835.447Z",
  transform: "translate(-643.781 -668.34)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_622",
  "data-name": "Group 622",
  transform: "translate(10.385 8.656)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_617",
  "data-name": "Group 617",
  transform: "translate(0.15 0.099)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_616",
  "data-name": "Group 616"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_615",
  "data-name": "Group 615"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_614",
  "data-name": "Group 614"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1136",
  "data-name": "Path 1136",
  d: "M473.224,679.048c-.9-.07-1.763-.155-2.57-.253l.043.074c.8.1,1.66.182,2.556.252Z",
  transform: "translate(-470.654 -678.795)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_621",
  "data-name": "Group 621"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_620",
  "data-name": "Group 620"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_619",
  "data-name": "Group 619"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_618",
  "data-name": "Group 618"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1137",
  "data-name": "Path 1137",
  d: "M472.239,678.46l-.127-.01c-.9-.071-1.766-.155-2.56-.252l-.04,0-.144-.248.16.02c.795.1,1.658.182,2.566.253l.05,0Z",
  transform: "translate(-469.368 -677.945)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_631",
  "data-name": "Group 631",
  transform: "translate(18.992 9.115)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_626",
  "data-name": "Group 626",
  transform: "translate(0.083 0.084)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_625",
  "data-name": "Group 625"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_624",
  "data-name": "Group 624"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_623",
  "data-name": "Group 623"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1138",
  "data-name": "Path 1138",
  d: "M546.577,682.586c-.968.031-1.952.045-2.936.042,0,.023,0,.047,0,.071.977,0,1.957-.01,2.92-.041Z",
  transform: "translate(-543.637 -682.586)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_630",
  "data-name": "Group 630"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_629",
  "data-name": "Group 629"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_628",
  "data-name": "Group 628"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_627",
  "data-name": "Group 627"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1139",
  "data-name": "Path 1139",
  d: "M543.269,682.146h-.341l.009-.232h.077c.987,0,1.973-.011,2.933-.042l.108,0-.063.234-.059,0C545.075,682.132,544.18,682.146,543.269,682.146Z",
  transform: "translate(-542.928 -681.868)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_640",
  "data-name": "Group 640",
  transform: "translate(24.838 8.681)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_635",
  "data-name": "Group 635",
  transform: "translate(0.135 0.102)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_634",
  "data-name": "Group 634"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_633",
  "data-name": "Group 633"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_632",
  "data-name": "Group 632"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1140",
  "data-name": "Path 1140",
  d: "M596.588,679.112l.05-.074q-.841.109-1.827.2c-.238.021-.479.041-.722.059l-.036.072c.241-.018.481-.038.718-.058Q595.75,679.221,596.588,679.112Z",
  transform: "translate(-594.053 -679.038)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_639",
  "data-name": "Group 639"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_638",
  "data-name": "Group 638"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_637",
  "data-name": "Group 637"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_636",
  "data-name": "Group 636"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1141",
  "data-name": "Path 1141",
  d: "M592.9,678.685l.12-.24.045,0c.243-.018.483-.038.721-.059.652-.058,1.266-.124,1.824-.2l.173-.022-.167.251-.036,0c-.559.073-1.172.139-1.82.2-.238.021-.477.041-.719.059Z",
  transform: "translate(-592.896 -678.164)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_649",
  "data-name": "Group 649",
  transform: "translate(8.056 8.288)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_644",
  "data-name": "Group 644",
  transform: "translate(0.187 0.117)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_643",
  "data-name": "Group 643"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_642",
  "data-name": "Group 642"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_641",
  "data-name": "Group 641"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1142",
  "data-name": "Path 1142",
  d: "M453.288,676.146c-.8-.1-1.551-.214-2.224-.341l.055.075c.67.127,1.412.241,2.212.34Z",
  transform: "translate(-451.064 -675.805)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_648",
  "data-name": "Group 648"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_647",
  "data-name": "Group 647"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_646",
  "data-name": "Group 646"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_645",
  "data-name": "Group 645"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1143",
  "data-name": "Path 1143",
  d: "M452.07,675.435l-.161-.02c-.807-.1-1.552-.215-2.217-.341l-.031-.006-.2-.266.2.038c.655.124,1.4.239,2.219.341l.039,0Z",
  transform: "translate(-449.466 -674.803)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_658",
  "data-name": "Group 658",
  transform: "translate(27.406 8.316)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_653",
  "data-name": "Group 653",
  transform: "translate(0.168 0.126)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_652",
  "data-name": "Group 652"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_651",
  "data-name": "Group 651"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_650",
  "data-name": "Group 650"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1144",
  "data-name": "Path 1144",
  d: "M618.325,676.12q-.863.182-2,.333l-.05.074q1.133-.149,1.993-.331Z",
  transform: "translate(-616.271 -676.12)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_657",
  "data-name": "Group 657"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_656",
  "data-name": "Group 656"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_655",
  "data-name": "Group 655"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_654",
  "data-name": "Group 654"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1145",
  "data-name": "Path 1145",
  d: "M614.839,675.679l.1-.148.049-.073.02-.031.036,0c.748-.1,1.42-.21,2-.332l.223-.047-.224.274-.027.006c-.58.123-1.252.235-2,.333Z",
  transform: "translate(-614.839 -675.043)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_667",
  "data-name": "Group 667",
  transform: "translate(15.973 9.093)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_662",
  "data-name": "Group 662",
  transform: "translate(0.095 0.084)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_661",
  "data-name": "Group 661"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_660",
  "data-name": "Group 660"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_659",
  "data-name": "Group 659"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1146",
  "data-name": "Path 1146",
  d: "M520.87,682.466c-.983,0-1.964-.024-2.926-.062,0,.024.009.048.012.071.956.037,1.932.058,2.91.062C520.868,682.514,520.869,682.49,520.87,682.466Z",
  transform: "translate(-517.944 -682.404)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_666",
  "data-name": "Group 666"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_665",
  "data-name": "Group 665"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_664",
  "data-name": "Group 664"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_663",
  "data-name": "Group 663"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1147",
  "data-name": "Path 1147",
  d: "M520.224,681.982h-.075c-.977,0-1.957-.024-2.913-.061l-.066,0-.039-.234.1,0c.954.037,1.937.058,2.923.062h.083l0,.083c0,.025,0,.05,0,.074Z",
  transform: "translate(-517.132 -681.684)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_676",
  "data-name": "Group 676",
  transform: "translate(13.06 8.924)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_671",
  "data-name": "Group 671",
  transform: "translate(0.122 0.09)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_670",
  "data-name": "Group 670"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_669",
  "data-name": "Group 669"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_668",
  "data-name": "Group 668"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1148",
  "data-name": "Path 1148",
  d: "M496.084,681.17c-.961-.038-1.9-.091-2.8-.16l.028.072c.9.069,1.833.122,2.788.16C496.093,681.218,496.088,681.194,496.084,681.17Z",
  transform: "translate(-493.28 -681.01)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_675",
  "data-name": "Group 675"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_674",
  "data-name": "Group 674"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_673",
  "data-name": "Group 673"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_672",
  "data-name": "Group 672"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1149",
  "data-name": "Path 1149",
  d: "M495.27,680.646l-.1,0c-.959-.038-1.9-.092-2.791-.16l-.05,0-.095-.238.128.01c.9.069,1.843.123,2.8.16l.066,0Z",
  transform: "translate(-492.237 -680.24)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_685",
  "data-name": "Group 685",
  transform: "translate(29.399 7.851)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_680",
  "data-name": "Group 680",
  transform: "translate(0.215 0.188)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_679",
  "data-name": "Group 679"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_678",
  "data-name": "Group 678"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_677",
  "data-name": "Group 677"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1150",
  "data-name": "Path 1150",
  d: "M635.2,672.673a10.792,10.792,0,0,1-1.423.393c-.021.025-.04.05-.062.075a10.7,10.7,0,0,0,1.416-.39Z",
  transform: "translate(-633.716 -672.673)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_684",
  "data-name": "Group 684"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_683",
  "data-name": "Group 683"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_682",
  "data-name": "Group 682"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_681",
  "data-name": "Group 681"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1151",
  "data-name": "Path 1151",
  d: "M631.879,671.849l.154-.181.035-.042.044-.053.027-.006a10.763,10.763,0,0,0,1.412-.39l.307-.113-.22.242-.068.077-.013.016-.019.007a10.8,10.8,0,0,1-1.426.394Z",
  transform: "translate(-631.879 -671.064)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_694",
  "data-name": "Group 694",
  transform: "translate(9.093 5.663)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_689",
  "data-name": "Group 689",
  transform: "translate(0.116 0.095)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_688",
  "data-name": "Group 688"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_687",
  "data-name": "Group 687"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_686",
  "data-name": "Group 686"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1152",
  "data-name": "Path 1152",
  d: "M462.326,653.475c-1.054-.081-2.063-.181-3.007-.3l.031.091c.941.116,1.946.215,3,.3C462.339,653.535,462.333,653.5,462.326,653.475Z",
  transform: "translate(-459.319 -653.178)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_693",
  "data-name": "Group 693"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_692",
  "data-name": "Group 692"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_691",
  "data-name": "Group 691"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_690",
  "data-name": "Group 690"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1153",
  "data-name": "Path 1153",
  d: "M461.572,652.934l-.109-.008c-1.051-.081-2.06-.181-3-.3l-.05-.006-.087-.26.126.016c.941.115,1.951.215,3,.3l.058,0Z",
  transform: "translate(-458.325 -652.363)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_703",
  "data-name": "Group 703",
  transform: "translate(29.039 5.279)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_698",
  "data-name": "Group 698",
  transform: "translate(0.125 0.113)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_697",
  "data-name": "Group 697"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_696",
  "data-name": "Group 696"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_695",
  "data-name": "Group 695"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1154",
  "data-name": "Path 1154",
  d: "M632.252,650.054q-1.009.213-2.344.39c-.013.03-.025.061-.037.091.885-.116,1.666-.247,2.337-.389Z",
  transform: "translate(-629.87 -650.054)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_702",
  "data-name": "Group 702"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_701",
  "data-name": "Group 701"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_700",
  "data-name": "Group 700"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_699",
  "data-name": "Group 699"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1155",
  "data-name": "Path 1155",
  d: "M628.8,649.78l.05-.127.038-.093.018-.043.046-.006c.87-.114,1.657-.245,2.338-.389l.162-.034-.135.276-.038.008c-.683.145-1.471.276-2.343.39Z",
  transform: "translate(-628.801 -649.088)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_712",
  "data-name": "Group 712",
  transform: "translate(22.626 6.01)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_707",
  "data-name": "Group 707",
  transform: "translate(0.094 0.089)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_706",
  "data-name": "Group 706"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_705",
  "data-name": "Group 705"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_704",
  "data-name": "Group 704"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1156",
  "data-name": "Path 1156",
  d: "M578.129,656.09c-1.072.08-2.184.138-3.316.176l-.014.089c1.127-.038,2.236-.1,3.3-.175Z",
  transform: "translate(-574.799 -656.09)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_711",
  "data-name": "Group 711"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_710",
  "data-name": "Group 710"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_709",
  "data-name": "Group 709"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_708",
  "data-name": "Group 708"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1157",
  "data-name": "Path 1157",
  d: "M573.993,655.768l.041-.251.065,0c1.15-.039,2.265-.1,3.313-.176l.116-.009-.075.255-.055,0c-1.044.078-2.156.137-3.307.175Z",
  transform: "translate(-573.993 -655.33)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_721",
  "data-name": "Group 721",
  transform: "translate(26.006 5.694)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_716",
  "data-name": "Group 716",
  transform: "translate(0.11 0.098)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_715",
  "data-name": "Group 715"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_714",
  "data-name": "Group 714"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_713",
  "data-name": "Group 713"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1158",
  "data-name": "Path 1158",
  d: "M606.792,653.562c.013-.03.025-.061.037-.091q-.985.128-2.138.23-.418.038-.845.069l-.026.09q.426-.031.842-.069Q605.81,653.69,606.792,653.562Z",
  transform: "translate(-603.82 -653.471)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_720",
  "data-name": "Group 720"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_719",
  "data-name": "Group 719"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_718",
  "data-name": "Group 718"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_717",
  "data-name": "Group 717"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1159",
  "data-name": "Path 1159",
  d: "M602.878,653.211l.075-.255.056,0q.426-.031.844-.069c.76-.067,1.478-.144,2.135-.23l.138-.018-.109.263-.046.006c-.678.087-1.4.165-2.133.229q-.417.037-.843.069Z",
  transform: "translate(-602.878 -652.635)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_730",
  "data-name": "Group 730",
  transform: "translate(33.082 4.028)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_725",
  "data-name": "Group 725",
  transform: "translate(0.172 0.37)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_724",
  "data-name": "Group 724"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_723",
  "data-name": "Group 723"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_722",
  "data-name": "Group 722"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1160",
  "data-name": "Path 1160",
  d: "M665.825,641.553a3.138,3.138,0,0,1-.953.509l-.051.094a3.128,3.128,0,0,0,.95-.507Z",
  transform: "translate(-664.821 -641.553)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_729",
  "data-name": "Group 729"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_728",
  "data-name": "Group 728"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_727",
  "data-name": "Group 727"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_726",
  "data-name": "Group 726"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1161",
  "data-name": "Path 1161",
  d: "M663.354,639.514l.167-.309.028-.01a3.066,3.066,0,0,0,.928-.494l.35-.31-.3.526a3.219,3.219,0,0,1-.975.522Z",
  transform: "translate(-663.354 -638.391)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_739",
  "data-name": "Group 739",
  transform: "translate(31.412 4.77)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_734",
  "data-name": "Group 734",
  transform: "translate(0.146 0.15)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_733",
  "data-name": "Group 733"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_732",
  "data-name": "Group 732"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_731",
  "data-name": "Group 731"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1162",
  "data-name": "Path 1162",
  d: "M652.035,646.018a12.457,12.457,0,0,1-1.664.46l-.045.092a12.641,12.641,0,0,0,1.658-.458Z",
  transform: "translate(-650.326 -646.018)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_738",
  "data-name": "Group 738"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_737",
  "data-name": "Group 737"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_736",
  "data-name": "Group 736"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_735",
  "data-name": "Group 735"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1163",
  "data-name": "Path 1163",
  d: "M649.082,645.549l.136-.276.038-.008a12.43,12.43,0,0,0,1.653-.457l.2-.075-.17.31-.028.01a12.76,12.76,0,0,1-1.669.461Z",
  transform: "translate(-649.082 -644.733)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_748",
  "data-name": "Group 748",
  transform: "translate(4.252 4.711)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_743",
  "data-name": "Group 743",
  transform: "translate(0.151 0.131)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_742",
  "data-name": "Group 742"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_741",
  "data-name": "Group 741"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_740",
  "data-name": "Group 740"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1164",
  "data-name": "Path 1164",
  d: "M420.34,645.936l-.04-.092c-.537-.1-1.033-.214-1.481-.331-.206-.054-.4-.108-.575-.163.015.032.031.063.047.095.178.055.369.108.573.162C419.311,645.724,419.8,645.834,420.34,645.936Z",
  transform: "translate(-418.244 -645.35)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_747",
  "data-name": "Group 747"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_746",
  "data-name": "Group 746"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_745",
  "data-name": "Group 745"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_744",
  "data-name": "Group 744"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1165",
  "data-name": "Path 1165",
  d: "M419.335,645.053l-.15-.029c-.538-.1-1.036-.214-1.482-.331-.206-.054-.4-.109-.576-.163l-.032-.01-.015-.03c-.016-.032-.033-.064-.048-.1l-.079-.166.175.054c.164.051.351.1.571.162.444.116.941.227,1.476.33l.042.008Z",
  transform: "translate(-416.953 -644.228)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_757",
  "data-name": "Group 757",
  transform: "translate(2.857 4.067)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_752",
  "data-name": "Group 752",
  transform: "translate(0.213 0.225)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_751",
  "data-name": "Group 751"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_750",
  "data-name": "Group 750"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_749",
  "data-name": "Group 749"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1166",
  "data-name": "Path 1166",
  d: "M408.135,641.179a5.938,5.938,0,0,1-1.285-.536l.052.1a5.919,5.919,0,0,0,1.28.534Z",
  transform: "translate(-406.85 -640.643)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_756",
  "data-name": "Group 756"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_755",
  "data-name": "Group 755"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_754",
  "data-name": "Group 754"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_753",
  "data-name": "Group 753"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1167",
  "data-name": "Path 1167",
  d: "M406.734,639.712l-.182-.057a6.023,6.023,0,0,1-1.3-.542l-.018-.011-.205-.378.255.156a5.882,5.882,0,0,0,1.267.528l.032.01Z",
  transform: "translate(-405.03 -638.724)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_766",
  "data-name": "Group 766",
  transform: "translate(6.392 5.241)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_761",
  "data-name": "Group 761",
  transform: "translate(0.135 0.107)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_760",
  "data-name": "Group 760"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_759",
  "data-name": "Group 759"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_758",
  "data-name": "Group 758"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1168",
  "data-name": "Path 1168",
  d: "M438.994,650.08c-.94-.117-1.814-.251-2.6-.4l.04.093c.785.149,1.656.281,2.593.4Z",
  transform: "translate(-436.392 -649.68)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_765",
  "data-name": "Group 765"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_764",
  "data-name": "Group 764"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_763",
  "data-name": "Group 763"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_762",
  "data-name": "Group 762"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1169",
  "data-name": "Path 1169",
  d: "M438.125,649.457l-.126-.016c-.954-.119-1.828-.253-2.6-.4l-.042-.008-.119-.272.15.028c.777.147,1.651.281,2.6.4l.05.006Z",
  transform: "translate(-435.241 -648.763)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_775",
  "data-name": "Group 775",
  transform: "translate(15.593 6.169)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_770",
  "data-name": "Group 770",
  transform: "translate(0.089 0.084)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_769",
  "data-name": "Group 769"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_768",
  "data-name": "Group 768"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_767",
  "data-name": "Group 767"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1170",
  "data-name": "Path 1170",
  d: "M518.065,657.483c-1.15-.005-2.3-.029-3.423-.073l.009.089c1.121.043,2.265.068,3.411.073C518.063,657.542,518.064,657.512,518.065,657.483Z",
  transform: "translate(-514.642 -657.41)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_774",
  "data-name": "Group 774"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_773",
  "data-name": "Group 773"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_772",
  "data-name": "Group 772"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_771",
  "data-name": "Group 771"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1171",
  "data-name": "Path 1171",
  d: "M517.469,657.02h-.078c-1.131,0-2.28-.029-3.414-.073l-.069,0-.026-.251.092,0c1.123.043,2.273.068,3.42.073h.083Z",
  transform: "translate(-513.881 -656.693)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_784",
  "data-name": "Group 784",
  transform: "translate(12.202 5.973)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_779",
  "data-name": "Group 779",
  transform: "translate(0.103 0.088)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_778",
  "data-name": "Group 778"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_777",
  "data-name": "Group 777"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_776",
  "data-name": "Group 776"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1172",
  "data-name": "Path 1172",
  d: "M489.063,655.962c-1.124-.044-2.224-.107-3.281-.187l.021.09c1.052.08,2.149.142,3.269.187Z",
  transform: "translate(-485.782 -655.775)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_783",
  "data-name": "Group 783"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_782",
  "data-name": "Group 782"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_781",
  "data-name": "Group 781"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_780",
  "data-name": "Group 780"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1173",
  "data-name": "Path 1173",
  d: "M488.382,655.469l-.093,0c-1.144-.046-2.244-.109-3.272-.187l-.058,0-.06-.254.109.008c1.066.081,2.169.144,3.278.187l.07,0Z",
  transform: "translate(-484.899 -655.019)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_793",
  "data-name": "Group 793",
  transform: "translate(19.117 6.194)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_788",
  "data-name": "Group 788",
  transform: "translate(0.083 0.084)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_787",
  "data-name": "Group 787"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_786",
  "data-name": "Group 786"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_785",
  "data-name": "Group 785"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1174",
  "data-name": "Path 1174",
  d: "M548.151,657.62c-1.133.036-2.284.052-3.434.048,0,.03,0,.06,0,.089,1.146,0,2.294-.012,3.423-.048Z",
  transform: "translate(-544.713 -657.62)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_792",
  "data-name": "Group 792"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_791",
  "data-name": "Group 791"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_790",
  "data-name": "Group 790"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_789",
  "data-name": "Group 789"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1175",
  "data-name": "Path 1175",
  d: "M544.433,657.207H544l0-.083c0-.031,0-.06,0-.091l0-.077h.077c1.156,0,2.311-.012,3.432-.048l.1,0-.04.251-.066,0C546.5,657.191,545.461,657.207,544.433,657.207Z",
  transform: "translate(-544.004 -656.905)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_802",
  "data-name": "Group 802",
  transform: "translate(1.537 0.602)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_797",
  "data-name": "Group 797",
  transform: "translate(0.09 0.082)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_796",
  "data-name": "Group 796"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_795",
  "data-name": "Group 795"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_794",
  "data-name": "Group 794"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1176",
  "data-name": "Path 1176",
  d: "M395.906,610.3c-.616-.191-1.389-.515-1.379-.479a6.492,6.492,0,0,0,1.407.587C395.924,610.369,395.914,610.333,395.906,610.3Z",
  transform: "translate(-394.526 -609.815)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_801",
  "data-name": "Group 801"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_800",
  "data-name": "Group 800"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_799",
  "data-name": "Group 799"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_798",
  "data-name": "Group 798"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1177",
  "data-name": "Path 1177",
  d: "M395.365,609.9l-.139-.043a6.584,6.584,0,0,1-1.425-.6l-.027-.016-.022-.078.036-.035c.047-.043.047-.043.5.126.269.1.636.237.956.337l.044.013.011.044c.009.036.018.071.027.107Z",
  transform: "translate(-393.753 -609.112)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_811",
  "data-name": "Group 811",
  transform: "translate(11.641 2.433)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_806",
  "data-name": "Group 806",
  transform: "translate(0.09 0.088)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_805",
  "data-name": "Group 805"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_804",
  "data-name": "Group 804"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_803",
  "data-name": "Group 803"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1178",
  "data-name": "Path 1178",
  d: "M484.478,625.718c-1.233-.049-2.441-.118-3.6-.206,0,.035.008.07.012.1,1.156.088,2.362.157,3.593.206C484.481,625.787,484.479,625.753,484.478,625.718Z",
  transform: "translate(-480.878 -625.512)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_810",
  "data-name": "Group 810"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_809",
  "data-name": "Group 809"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_808",
  "data-name": "Group 808"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_807",
  "data-name": "Group 807"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1179",
  "data-name": "Path 1179",
  d: "M483.889,625.246l-.089,0c-1.231-.049-2.44-.118-3.6-.206l-.065-.005-.009-.065c0-.035-.008-.071-.012-.107l-.01-.1.1.007c1.156.088,2.366.157,3.6.206l.074,0,0,.09c0,.029,0,.058,0,.088Z",
  transform: "translate(-480.108 -624.764)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_820",
  "data-name": "Group 820",
  transform: "translate(2.946 1.064)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_815",
  "data-name": "Group 815",
  transform: "translate(0.114 0.119)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_814",
  "data-name": "Group 814"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_813",
  "data-name": "Group 813"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_812",
  "data-name": "Group 812"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1180",
  "data-name": "Path 1180",
  d: "M409.045,614.725l-.023-.106c-.589-.113-1.133-.234-1.625-.363-.225-.06-.435-.119-.631-.179.009.036.018.071.027.107.2.06.4.12.63.178C407.914,614.492,408.457,614.612,409.045,614.725Z",
  transform: "translate(-406.766 -614.077)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_819",
  "data-name": "Group 819"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_818",
  "data-name": "Group 818"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_817",
  "data-name": "Group 817"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_816",
  "data-name": "Group 816"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1181",
  "data-name": "Path 1181",
  d: "M408.289,613.928l-.119-.023c-.6-.116-1.15-.238-1.628-.364-.226-.059-.439-.119-.633-.179l-.043-.013-.075-.29.138.042c.183.056.389.115.628.178.485.127,1.03.248,1.62.361l.052.01Z",
  transform: "translate(-405.792 -613.059)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_829",
  "data-name": "Group 829",
  transform: "translate(32.769 1.14)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_824",
  "data-name": "Group 824",
  transform: "translate(0.11 0.129)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_823",
  "data-name": "Group 823"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_822",
  "data-name": "Group 822"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_821",
  "data-name": "Group 821"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1182",
  "data-name": "Path 1182",
  d: "M663.472,614.809a13.68,13.68,0,0,1-1.826.5c-.009.036-.019.071-.027.107a13.909,13.909,0,0,0,1.823-.5C663.452,614.881,663.462,614.845,663.472,614.809Z",
  transform: "translate(-661.619 -614.809)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_828",
  "data-name": "Group 828"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_827",
  "data-name": "Group 827"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_826",
  "data-name": "Group 826"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_825",
  "data-name": "Group 825"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1183",
  "data-name": "Path 1183",
  d: "M660.682,614.554l.071-.281.049-.01a13.6,13.6,0,0,0,1.815-.5l.145-.053-.08.3-.039.014a14.021,14.021,0,0,1-1.834.506Z",
  transform: "translate(-660.682 -613.709)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_838",
  "data-name": "Group 838",
  transform: "translate(23.078 2.474)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_833",
  "data-name": "Group 833",
  transform: "translate(0.088 0.088)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_832",
  "data-name": "Group 832"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_831",
  "data-name": "Group 831"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_830",
  "data-name": "Group 830"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1184",
  "data-name": "Path 1184",
  d: "M582.242,625.963c.006-.035.011-.07.016-.105-1.177.088-2.4.152-3.639.193,0,.035-.006.07-.009.105,1.24-.042,2.458-.106,3.632-.193Z",
  transform: "translate(-578.61 -625.858)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_837",
  "data-name": "Group 837"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_836",
  "data-name": "Group 836"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_835",
  "data-name": "Group 835"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_834",
  "data-name": "Group 834"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1185",
  "data-name": "Path 1185",
  d: "M577.855,625.576l.025-.267.07,0c1.265-.042,2.488-.107,3.635-.193l.1-.008-.044.269-.063,0c-1.158.086-2.381.151-3.635.193Z",
  transform: "translate(-577.855 -625.107)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_847",
  "data-name": "Group 847",
  transform: "translate(34.621 0.718)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_842",
  "data-name": "Group 842",
  transform: "translate(0.123 0.083)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_841",
  "data-name": "Group 841"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_840",
  "data-name": "Group 840"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_839",
  "data-name": "Group 839"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1186",
  "data-name": "Path 1186",
  d: "M677.581,611.264c-.01.036-.02.072-.031.107a3.454,3.454,0,0,0,1.045-.557C678.606,610.778,678.057,611.085,677.581,611.264Z",
  transform: "translate(-677.55 -610.811)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_846",
  "data-name": "Group 846"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_845",
  "data-name": "Group 845"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_844",
  "data-name": "Group 844"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_843",
  "data-name": "Group 843"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1187",
  "data-name": "Path 1187",
  d: "M676.5,610.879l.087-.3.038-.014c.269-.1.566-.245.762-.341.269-.131.284-.138.332-.1l.04.034-.021.075-.017.015a3.53,3.53,0,0,1-1.07.572Z",
  transform: "translate(-676.503 -610.105)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_856",
  "data-name": "Group 856",
  transform: "translate(15.353 2.65)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_851",
  "data-name": "Group 851",
  transform: "translate(0.083 0.081)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_850",
  "data-name": "Group 850"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_849",
  "data-name": "Group 849"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_848",
  "data-name": "Group 848"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1188",
  "data-name": "Path 1188",
  d: "M516.3,627.384c-1.262-.005-2.522-.033-3.756-.08,0,.035,0,.07,0,.1,1.232.048,2.49.074,3.749.079C516.3,627.453,516.3,627.419,516.3,627.384Z",
  transform: "translate(-512.544 -627.304)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_855",
  "data-name": "Group 855"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_854",
  "data-name": "Group 854"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_853",
  "data-name": "Group 853"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_852",
  "data-name": "Group 852"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1189",
  "data-name": "Path 1189",
  d: "M515.749,626.961h-.078c-1.255-.005-2.518-.032-3.752-.079l-.072,0,0-.073c0-.032,0-.063,0-.1l0-.087.086-.008c1.241.048,2.5.074,3.754.08h.081v.081c0,.029,0,.057,0,.087Z",
  transform: "translate(-511.834 -626.615)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_865",
  "data-name": "Group 865",
  transform: "translate(30.147 1.681)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_860",
  "data-name": "Group 860",
  transform: "translate(0.102 0.106)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_859",
  "data-name": "Group 859"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_858",
  "data-name": "Group 858"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_857",
  "data-name": "Group 857"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1190",
  "data-name": "Path 1190",
  d: "M641.733,619.235c-.739.156-1.6.3-2.573.428l-.022.106c.973-.127,1.831-.271,2.568-.427Z",
  transform: "translate(-639.138 -619.235)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_864",
  "data-name": "Group 864"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_863",
  "data-name": "Group 863"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_862",
  "data-name": "Group 862"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_861",
  "data-name": "Group 861"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1191",
  "data-name": "Path 1191",
  d: "M638.267,619.067l.056-.273.057-.008c.96-.125,1.823-.269,2.567-.427l.126-.027-.07.281-.049.01c-.745.158-1.612.3-2.574.428Z",
  transform: "translate(-638.267 -618.333)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_874",
  "data-name": "Group 874",
  transform: "translate(8.239 2.095)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_869",
  "data-name": "Group 869",
  transform: "translate(0.095 0.093)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_868",
  "data-name": "Group 868"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_867",
  "data-name": "Group 867"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_866",
  "data-name": "Group 866"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1192",
  "data-name": "Path 1192",
  d: "M455.139,622.992c-1.156-.089-2.263-.2-3.3-.325.005.035.011.071.017.106,1.034.127,2.14.236,3.294.325C455.148,623.063,455.144,623.027,455.139,622.992Z",
  transform: "translate(-451.841 -622.667)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_873",
  "data-name": "Group 873"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_872",
  "data-name": "Group 872"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_871",
  "data-name": "Group 871"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_870",
  "data-name": "Group 870"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1193",
  "data-name": "Path 1193",
  d: "M454.523,622.485l-.1-.008c-1.168-.091-2.278-.2-3.3-.325l-.06-.008-.042-.271.1.013c1.03.126,2.138.236,3.295.325l.065,0,.009.065c0,.036.008.072.012.107Z",
  transform: "translate(-451.027 -621.874)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_883",
  "data-name": "Group 883",
  transform: "translate(5.286 1.637)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_878",
  "data-name": "Group 878",
  transform: "translate(0.104 0.102)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_877",
  "data-name": "Group 877"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_876",
  "data-name": "Group 876"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_875",
  "data-name": "Group 875"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1194",
  "data-name": "Path 1194",
  d: "M429.54,619.266c-1.032-.128-1.991-.275-2.855-.439.008.036.015.071.022.107.863.163,1.82.31,2.85.438C429.551,619.335,429.545,619.3,429.54,619.266Z",
  transform: "translate(-426.685 -618.827)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_882",
  "data-name": "Group 882"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_881",
  "data-name": "Group 881"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_880",
  "data-name": "Group 880"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_879",
  "data-name": "Group 879"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1195",
  "data-name": "Path 1195",
  d: "M428.763,618.684c-1.033-.128-1.994-.276-2.855-.438l-.052-.01-.059-.277.119.023c.848.161,1.807.308,2.85.438l.06.007.009.06c0,.03.01.059.015.089l.018.107Z",
  transform: "translate(-425.796 -617.958)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_892",
  "data-name": "Group 892",
  transform: "translate(26.803 2.131)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_887",
  "data-name": "Group 887",
  transform: "translate(0.095 0.094)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_886",
  "data-name": "Group 886"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_885",
  "data-name": "Group 885"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_884",
  "data-name": "Group 884"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1196",
  "data-name": "Path 1196",
  d: "M613.773,623.088c.007-.035.015-.07.022-.106q-1.081.14-2.345.253-.459.041-.927.076c-.006.035-.011.07-.016.105q.468-.036.925-.076Q612.694,623.228,613.773,623.088Z",
  transform: "translate(-610.506 -622.982)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_891",
  "data-name": "Group 891"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_890",
  "data-name": "Group 890"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_889",
  "data-name": "Group 889"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_888",
  "data-name": "Group 888"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1197",
  "data-name": "Path 1197",
  d: "M609.693,622.793l.043-.269.063,0c.312-.024.62-.049.926-.076.841-.075,1.629-.16,2.342-.252l.111-.015-.055.273-.057.008c-.718.093-1.507.178-2.345.253q-.458.04-.926.076Z",
  transform: "translate(-609.693 -622.176)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_901",
  "data-name": "Group 901",
  transform: "translate(19.215 2.674)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_896",
  "data-name": "Group 896",
  transform: "translate(0.083 0.083)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_895",
  "data-name": "Group 895"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_894",
  "data-name": "Group 894"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_893",
  "data-name": "Group 893"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1198",
  "data-name": "Path 1198",
  d: "M549.319,627.534c-1.243.04-2.507.057-3.769.053,0,.035,0,.07,0,.1,1.26,0,2.522-.013,3.763-.052C549.313,627.6,549.317,627.569,549.319,627.534Z",
  transform: "translate(-545.548 -627.534)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_900",
  "data-name": "Group 900"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_899",
  "data-name": "Group 899"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_898",
  "data-name": "Group 898"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_897",
  "data-name": "Group 897"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1199",
  "data-name": "Path 1199",
  d: "M545.3,627.144h-.46l0-.083c0-.033,0-.068,0-.1v-.081h.08c1.29,0,2.557-.014,3.766-.053l.089,0-.021.266-.072,0C547.572,627.126,546.434,627.144,545.3,627.144Z",
  transform: "translate(-544.84 -626.822)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_910",
  "data-name": "Group 910",
  transform: "translate(8.595 10.368)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_905",
  "data-name": "Group 905",
  transform: "translate(0.036 0.068)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_904",
  "data-name": "Group 904"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_903",
  "data-name": "Group 903"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_902",
  "data-name": "Group 902"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1200",
  "data-name": "Path 1200",
  d: "M454.378,693.156l.044.028Z",
  transform: "translate(-454.378 -693.156)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_909",
  "data-name": "Group 909"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_908",
  "data-name": "Group 908"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_907",
  "data-name": "Group 907"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_906",
  "data-name": "Group 906"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1201",
  "data-name": "Path 1201",
  d: "M454.105,692.739l-.035-.023.036-.072.043-.068-.043.068.043-.068-.043.068.05-.064.039.026Z",
  transform: "translate(-454.07 -692.576)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_919",
  "data-name": "Group 919",
  transform: "translate(14.968 12.995)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_914",
  "data-name": "Group 914",
  transform: "translate(0.016 0.079)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_913",
  "data-name": "Group 913"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_912",
  "data-name": "Group 912"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_911",
  "data-name": "Group 911"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1202",
  "data-name": "Path 1202",
  d: "M508.677,715.71h0Z",
  transform: "translate(-508.677 -715.71)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_918",
  "data-name": "Group 918"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_917",
  "data-name": "Group 917"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_916",
  "data-name": "Group 916"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_915",
  "data-name": "Group 915"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1203",
  "data-name": "Path 1203",
  d: "M508.573,715.19l-.031-.158h0Z",
  transform: "translate(-508.543 -715.031)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_928",
  "data-name": "Group 928",
  transform: "translate(14.969 12.996)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_923",
  "data-name": "Group 923",
  transform: "translate(0.017 0.079)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_922",
  "data-name": "Group 922"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_921",
  "data-name": "Group 921"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_920",
  "data-name": "Group 920"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1204",
  "data-name": "Path 1204",
  d: "M508.96,715.765c-.09-.017-.179-.035-.269-.055.074.016.147.032.221.046Z",
  transform: "translate(-508.691 -715.71)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_927",
  "data-name": "Group 927"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_926",
  "data-name": "Group 926"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_925",
  "data-name": "Group 925"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_924",
  "data-name": "Group 924"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1205",
  "data-name": "Path 1205",
  d: "M508.818,715.249l-.048-.009-.171-.035-.053-.011.034-.157h0l.051.011c.072.015.143.03.215.043h0Z",
  transform: "translate(-508.547 -715.036)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_937",
  "data-name": "Group 937",
  transform: "translate(25.421 12.012)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_932",
  "data-name": "Group 932",
  transform: "translate(0.031 0.074)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_931",
  "data-name": "Group 931"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_930",
  "data-name": "Group 930"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_929",
  "data-name": "Group 929"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1206",
  "data-name": "Path 1206",
  d: "M598.193,707.263l-.049.021Z",
  transform: "translate(-598.143 -707.263)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_936",
  "data-name": "Group 936",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_935",
  "data-name": "Group 935"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_934",
  "data-name": "Group 934"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_933",
  "data-name": "Group 933"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_195",
  "data-name": "Rectangle 195",
  width: 0.054,
  height: 0.161,
  transform: "translate(0 0.021) rotate(-22.454)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_946",
  "data-name": "Group 946",
  transform: "translate(25.044 12.033)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_941",
  "data-name": "Group 941",
  transform: "translate(0.029 0.075)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_940",
  "data-name": "Group 940"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_939",
  "data-name": "Group 939"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_938",
  "data-name": "Group 938"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1207",
  "data-name": "Path 1207",
  d: "M595.011,707.552c.091-.036.181-.074.272-.111-.125.052-.252.1-.379.152Z",
  transform: "translate(-594.904 -707.441)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_945",
  "data-name": "Group 945"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_944",
  "data-name": "Group 944"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_943",
  "data-name": "Group 943"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_942",
  "data-name": "Group 942"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1208",
  "data-name": "Path 1208",
  d: "M594.714,707.106l-.058-.15h0l.064-.025.185-.074.042-.017.086-.035h0l.061.149-.129.053-.145.058h0l-.043.017-.064.025h0Z",
  transform: "translate(-594.656 -706.804)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_951",
  "data-name": "Group 951",
  transform: "translate(22.791 0.789)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_950",
  "data-name": "Group 950"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_949",
  "data-name": "Group 949"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_948",
  "data-name": "Group 948"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_947",
  "data-name": "Group 947"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1209",
  "data-name": "Path 1209",
  d: "M575.438,622.951l-.037-.156a12.22,12.22,0,0,0,1.39-.444l.083-.034a12.355,12.355,0,0,0,2.794-1.571c.023-.017.046-.035.07-.055a13.762,13.762,0,0,0,2.376-2.307l.062-.077a16.03,16.03,0,0,0,1.864-2.941c.015-.032.029-.063.046-.094a18.483,18.483,0,0,0,1.263-3.481l.026-.1c.083-.335.156-.664.218-.98l.059.011,0-.012.157.031c-.07.349-.141.667-.217.973,0,.019-.01.04-.015.061l-.011.045a18.517,18.517,0,0,1-1.282,3.518c-.017.032-.031.061-.044.091a16.312,16.312,0,0,1-1.893,2.975l-.062.077a14.056,14.056,0,0,1-2.411,2.332c-.023.02-.049.039-.078.059a12.585,12.585,0,0,1-2.838,1.593l-.043.017-.046.017a12,12,0,0,1-1.386.444Z",
  transform: "translate(-575.4 -610.707)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_956",
  "data-name": "Group 956",
  transform: "translate(26.188 0.785)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_955",
  "data-name": "Group 955"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_954",
  "data-name": "Group 954"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_953",
  "data-name": "Group 953"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_952",
  "data-name": "Group 952"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1210",
  "data-name": "Path 1210",
  d: "M604.5,621.722l-.07-.145a15.316,15.316,0,0,0,2.013-1.175l.053-.038.03-.021a15.758,15.758,0,0,0,2.686-2.392l.07-.079a16.755,16.755,0,0,0,2.106-3.008c.016-.03.033-.061.051-.095a17.571,17.571,0,0,0,1.426-3.527l.031-.107c.042-.152.083-.307.122-.462l.156.039c-.039.156-.08.313-.123.467l-.031.108a17.728,17.728,0,0,1-1.44,3.56l-.051.094a16.918,16.918,0,0,1-2.128,3.04l-.07.079a15.919,15.919,0,0,1-2.713,2.415l-.031.022c-.017.012-.034.023-.05.036A15.484,15.484,0,0,1,604.5,621.722Z",
  transform: "translate(-604.432 -610.674)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_961",
  "data-name": "Group 961",
  transform: "translate(21.225 0.793)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_960",
  "data-name": "Group 960"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_959",
  "data-name": "Group 959"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_958",
  "data-name": "Group 958"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_957",
  "data-name": "Group 957"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1211",
  "data-name": "Path 1211",
  d: "M562.041,623.284l-.021-.159a7.793,7.793,0,0,0,1.882-.564l.068-.03a9.112,9.112,0,0,0,2.271-1.484l.06-.053a12.174,12.174,0,0,0,1.936-2.232l.049-.073a16.26,16.26,0,0,0,1.522-2.885l.037-.092a20.549,20.549,0,0,0,1.037-3.447c0-.018.007-.038.011-.058l.009-.046c.093-.447.176-.924.247-1.418l.082.012,0-.012.159.023c-.07.487-.154.963-.248,1.416-.006.032-.014.066-.022.1a20.531,20.531,0,0,1-1.051,3.48c-.015.033-.027.062-.039.092a16.321,16.321,0,0,1-1.548,2.917c-.019.026-.034.048-.049.07a12.36,12.36,0,0,1-1.976,2.267l-.061.053a9.374,9.374,0,0,1-2.329,1.51c-.013.008-.034.017-.053.025L564,622.7a8.2,8.2,0,0,1-1.915.575Z",
  transform: "translate(-562.02 -610.743)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_966",
  "data-name": "Group 966",
  transform: "translate(20.208 0.797)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_965",
  "data-name": "Group 965"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_964",
  "data-name": "Group 964"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_963",
  "data-name": "Group 963"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_962",
  "data-name": "Group 962"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1212",
  "data-name": "Path 1212",
  d: "M553.34,623.428l-.019-.16c.063-.008.127-.019.19-.031a4.3,4.3,0,0,0,1.387-.512l.047-.029a6.468,6.468,0,0,0,1.631-1.415l.046-.052a11.327,11.327,0,0,0,1.394-2.176c.013-.024.025-.048.037-.072a18.657,18.657,0,0,0,1.1-2.846l0-.016c.007-.024.014-.05.022-.076a26.565,26.565,0,0,0,.753-3.419l.007-.049c0-.02.006-.039.009-.059.085-.56.157-1.147.214-1.742l.16.015c-.057.6-.13,1.188-.215,1.753,0,.02-.006.038-.009.056l-.008.052a26.762,26.762,0,0,1-.758,3.441c-.008.026-.015.049-.021.071l-.005.018a18.807,18.807,0,0,1-1.112,2.872c-.013.026-.025.051-.038.074a11.477,11.477,0,0,1-1.414,2.206l-.046.052a6.618,6.618,0,0,1-1.67,1.448l-.047.03a4.454,4.454,0,0,1-1.434.531C553.473,623.408,553.407,623.42,553.34,623.428Z",
  transform: "translate(-553.321 -610.775)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_971",
  "data-name": "Group 971",
  transform: "translate(31.231 0.781)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_970",
  "data-name": "Group 970"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_969",
  "data-name": "Group 969"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_968",
  "data-name": "Group 968"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_967",
  "data-name": "Group 967"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1213",
  "data-name": "Path 1213",
  d: "M647.646,618.194l-.113-.115c.1-.1.2-.2.3-.3s.188-.2.281-.3c.019-.019.035-.036.05-.054l.023-.025a17.311,17.311,0,0,0,2.248-3.083l.055-.1a17.651,17.651,0,0,0,1.523-3.577l.153.047a17.788,17.788,0,0,1-1.536,3.61l-.055.1a17.476,17.476,0,0,1-2.269,3.112l-.022.024c-.017.019-.035.039-.054.058-.092.1-.187.2-.281.3S647.748,618.093,647.646,618.194Z",
  transform: "translate(-647.533 -610.642)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_976",
  "data-name": "Group 976",
  transform: "translate(25.471 0.784)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_975",
  "data-name": "Group 975"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_974",
  "data-name": "Group 974"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_973",
  "data-name": "Group 973"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_972",
  "data-name": "Group 972"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1214",
  "data-name": "Path 1214",
  d: "M598.365,622.044l-.063-.148c.234-.1.473-.208.712-.322l.018-.008a15.169,15.169,0,0,0,2.025-1.177l.023-.017c.021-.015.041-.03.062-.044a15.83,15.83,0,0,0,2.69-2.392c.024-.026.045-.052.067-.077a16.514,16.514,0,0,0,2.115-3.014l.02-.037c.01-.018.02-.036.029-.054a17.476,17.476,0,0,0,1.432-3.53c.009-.028.015-.051.021-.075l.009-.033c.041-.149.081-.3.12-.447l.155.04c-.039.15-.08.3-.121.45l-.008.031c-.007.027-.014.053-.023.081a17.615,17.615,0,0,1-1.443,3.557c-.009.019-.021.039-.032.059l-.019.035a16.69,16.69,0,0,1-2.134,3.042c-.023.027-.046.054-.07.081a16,16,0,0,1-2.719,2.417c-.021.014-.039.027-.057.04l-.026.019a15.367,15.367,0,0,1-2.048,1.191l-.014.014h-.019C598.833,621.839,598.6,621.946,598.365,622.044Z",
  transform: "translate(-598.302 -610.668)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_981",
  "data-name": "Group 981",
  transform: "translate(19.978 0.797)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_980",
  "data-name": "Group 980"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_979",
  "data-name": "Group 979"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_978",
  "data-name": "Group 978"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_977",
  "data-name": "Group 977"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1215",
  "data-name": "Path 1215",
  d: "M551.37,623.455l-.013-.16.025,0c.067-.006.135-.012.2-.022s.129-.02.192-.031a4.3,4.3,0,0,0,1.345-.51c.018-.011.036-.022.053-.031a6.44,6.44,0,0,0,1.606-1.411l.044-.052a11.379,11.379,0,0,0,1.377-2.174l.035-.072a18.2,18.2,0,0,0,1.089-2.843c0-.017.01-.035.016-.054l.011-.036a26.707,26.707,0,0,0,.745-3.422l.007-.049c0-.02.006-.04.009-.059.082-.546.152-1.12.211-1.75l.16.015c-.06.634-.13,1.21-.213,1.761,0,.02-.006.038-.009.056l-.008.052a26.829,26.829,0,0,1-.75,3.441l-.011.038c0,.016-.01.033-.015.05a18.386,18.386,0,0,1-1.1,2.871l-.035.072a11.54,11.54,0,0,1-1.4,2.206l-.044.053a6.6,6.6,0,0,1-1.651,1.448c-.019.01-.032.018-.046.026a4.454,4.454,0,0,1-1.393.53c-.074.013-.141.026-.208.034s-.14.016-.211.023Z",
  transform: "translate(-551.357 -610.777)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_986",
  "data-name": "Group 986",
  transform: "translate(19.266 0.8)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_985",
  "data-name": "Group 985"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_984",
  "data-name": "Group 984"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_983",
  "data-name": "Group 983"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_982",
  "data-name": "Group 982"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1216",
  "data-name": "Path 1216",
  d: "M545.27,623.519v-.161h.015a1.607,1.607,0,0,0,.982-.513l.013-.014.013-.014a5.151,5.151,0,0,0,.906-1.371c.007-.015.014-.03.02-.044A13.858,13.858,0,0,0,548,619.25l.018-.069a27.973,27.973,0,0,0,.624-2.826l.014-.086c.179-1.058.323-2.205.43-3.411l0-.052c0-.019,0-.038.005-.057.058-.66.1-1.315.137-1.944l.16.008c-.033.631-.079,1.288-.137,1.952l-.01.108c-.107,1.208-.252,2.36-.432,3.42l-.014.086a28.194,28.194,0,0,1-.627,2.842l-.018.071a13.967,13.967,0,0,1-.793,2.172.509.509,0,0,1-.023.052,5.3,5.3,0,0,1-.936,1.413l-.013.015-.014.015a1.753,1.753,0,0,1-1.073.557A.183.183,0,0,1,545.27,623.519Z",
  transform: "translate(-545.27 -610.805)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_991",
  "data-name": "Group 991",
  transform: "translate(18.487 0.803)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_990",
  "data-name": "Group 990"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_989",
  "data-name": "Group 989"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_988",
  "data-name": "Group 988"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_987",
  "data-name": "Group 987"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1217",
  "data-name": "Path 1217",
  d: "M538.7,623.553h-.019v-.083l-.067,0v-.051l.043-.021h0a1.749,1.749,0,0,0,.1-.462l.044-.013-.041,0q.073-.494.141-1.386a.469.469,0,0,1,0-.055c.046-.641.088-1.363.124-2.144,0-.024,0-.045,0-.066.04-.866.077-1.817.108-2.828,0-.014,0-.03,0-.046v-.04c.035-1.048.063-2.2.086-3.413,0-.036,0-.07,0-.1q.018-.973.035-2.008l.11,0v0l.161,0q-.015,1.035-.037,2.007l0,.1c-.024,1.119-.056,2.267-.094,3.414l0,.044c0,.016,0,.032,0,.047-.037,1.041-.078,1.993-.122,2.824,0,.02,0,.047,0,.074-.047.871-.094,1.574-.143,2.148a.393.393,0,0,0,0,.044c-.056.629-.11,1.083-.165,1.4a.089.089,0,0,1,0,.024c-.067.386-.127.52-.191.569v.023Z",
  transform: "translate(-538.615 -610.83)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_996",
  "data-name": "Group 996",
  transform: "translate(19.217 0.8)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_995",
  "data-name": "Group 995"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_994",
  "data-name": "Group 994"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_993",
  "data-name": "Group 993"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_992",
  "data-name": "Group 992"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1218",
  "data-name": "Path 1218",
  d: "M544.891,623.522h-.039v-.161l.061,0a1.537,1.537,0,0,0,.941-.511l.017-.017a5.138,5.138,0,0,0,.892-1.38l.024-.05a13.956,13.956,0,0,0,.763-2.144c.007-.021.011-.037.015-.053l.005-.019a28.832,28.832,0,0,0,.609-2.823c0-.03.008-.06.015-.092.173-1.058.315-2.205.421-3.407l.008-.1c.055-.651.1-1.308.133-1.953l.16.008c-.033.647-.078,1.305-.133,1.956l-.008.1c-.107,1.207-.249,2.358-.424,3.424-.006.032-.01.059-.014.088a29.041,29.041,0,0,1-.613,2.842l0,.018c-.005.019-.01.038-.017.058a14.074,14.074,0,0,1-.771,2.165c-.008.019-.017.036-.026.053a5.286,5.286,0,0,1-.912,1.412.4.4,0,0,1-.034.033,1.676,1.676,0,0,1-1.042.552l-.01,0H544.9Z",
  transform: "translate(-544.852 -610.806)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1001",
  "data-name": "Group 1001",
  transform: "translate(11.507 0.8)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1000",
  "data-name": "Group 1000"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_999",
  "data-name": "Group 999"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_998",
  "data-name": "Group 998"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_997",
  "data-name": "Group 997"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1219",
  "data-name": "Path 1219",
  d: "M484.676,623.472l-.024,0a3.1,3.1,0,0,1-1.528-.6l-.039-.028a5.777,5.777,0,0,1-1.341-1.461.472.472,0,0,1-.038-.057,11.841,11.841,0,0,1-1.113-2.207l-.028-.07a20.877,20.877,0,0,1-.86-2.876l-.01-.041c0-.015-.007-.031-.011-.045a32.233,32.233,0,0,1-.564-3.449l-.012-.107c-.062-.583-.11-1.162-.143-1.72l.16-.009c.033.556.081,1.132.143,1.712l.012.106a32.009,32.009,0,0,0,.56,3.427c0,.013.008.03.012.048l.01.039a20.676,20.676,0,0,0,.853,2.854l.028.07a11.7,11.7,0,0,0,1.1,2.184.366.366,0,0,0,.031.045,5.636,5.636,0,0,0,1.3,1.425l.031.022a2.957,2.957,0,0,0,1.458.577l.017,0Z",
  transform: "translate(-478.964 -610.801)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1006",
  "data-name": "Group 1006",
  transform: "translate(15.185 0.802)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1005",
  "data-name": "Group 1005"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1004",
  "data-name": "Group 1004"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1003",
  "data-name": "Group 1003"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1002",
  "data-name": "Group 1002"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1220",
  "data-name": "Path 1220",
  d: "M513.141,623.534l-.068,0a1.159,1.159,0,0,1-.768-.578l-.019-.027a5.875,5.875,0,0,1-.626-1.418l-.006-.022c0-.011-.007-.023-.01-.036a18.326,18.326,0,0,1-.515-2.165l-.012-.073c-.149-.83-.281-1.786-.393-2.841l0-.042c0-.017,0-.034,0-.051-.11-1.09-.194-2.241-.249-3.419l-.006-.1c-.026-.565-.047-1.177-.066-1.925l.161,0v0l.108,0c.015.7.036,1.328.063,1.925l0,.1c.058,1.238.139,2.386.241,3.414l.01.087c.1,1.035.229,1.986.375,2.831l.012.071a18.435,18.435,0,0,0,.494,2.153.34.34,0,0,0,.015.047,5.787,5.787,0,0,0,.587,1.384l.018.026a.979.979,0,0,0,.619.505l.041,0Z",
  transform: "translate(-510.394 -610.824)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1011",
  "data-name": "Group 1011",
  transform: "translate(5.133 0.791)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1010",
  "data-name": "Group 1010"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1009",
  "data-name": "Group 1009"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1008",
  "data-name": "Group 1008"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1007",
  "data-name": "Group 1007"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1221",
  "data-name": "Path 1221",
  d: "M434,623.016a10.226,10.226,0,0,1-1.523-.518l-.027-.012-.048-.02a11.083,11.083,0,0,1-2.583-1.606l-.067-.055a13.222,13.222,0,0,1-2.173-2.341l-.055-.075a16.227,16.227,0,0,1-1.686-2.979c-.013-.032-.026-.063-.04-.093a19.444,19.444,0,0,1-1.119-3.52c-.006-.031-.012-.058-.018-.087l0-.019c-.065-.307-.125-.622-.179-.938l.158-.027c.053.313.112.626.177.93l0,.018c.007.031.014.061.019.091a19.294,19.294,0,0,0,1.108,3.486c.014.03.029.064.042.1a16.069,16.069,0,0,0,1.667,2.946l.054.075a13.057,13.057,0,0,0,2.146,2.312l.067.055a10.924,10.924,0,0,0,2.542,1.581l.05.021.026.011a10.089,10.089,0,0,0,1.5.51Z",
  transform: "translate(-424.484 -610.727)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1016",
  "data-name": "Group 1016",
  transform: "translate(7.975 0.795)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1015",
  "data-name": "Group 1015"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1014",
  "data-name": "Group 1014"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1013",
  "data-name": "Group 1013"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1012",
  "data-name": "Group 1012"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1222",
  "data-name": "Path 1222",
  d: "M457.193,623.357l-.027,0c-.034,0-.064-.008-.095-.013a.121.121,0,0,1-.028-.005l-.051-.008-.068-.011c-.088-.015-.166-.029-.245-.046a6.339,6.339,0,0,1-1.607-.568l-.061-.031a8.128,8.128,0,0,1-2.022-1.52c-.022-.022-.04-.04-.056-.059a11.723,11.723,0,0,1-1.7-2.265l-.043-.074a16.915,16.915,0,0,1-1.313-2.922l-.031-.091a22.724,22.724,0,0,1-.869-3.478l-.018-.1c-.073-.447-.137-.91-.191-1.379l.159-.018v.01l.089-.01c.047.434.109.885.189,1.38,0,.036.01.069.016.1a22.732,22.732,0,0,0,.855,3.454l.031.092a16.907,16.907,0,0,0,1.29,2.891l.043.073a11.58,11.58,0,0,0,1.659,2.237l.019.02c.01.01.019.02.029.029a7.866,7.866,0,0,0,1.968,1.491l.021.012.042.023a6.275,6.275,0,0,0,1.527.545c.072.015.144.029.217.042h.005l.01,0,.074.011.086.014.1.013Z",
  transform: "translate(-448.774 -610.763)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1021",
  "data-name": "Group 1021",
  transform: "translate(11.405 0.799)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1020",
  "data-name": "Group 1020"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1019",
  "data-name": "Group 1019"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1018",
  "data-name": "Group 1018"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1017",
  "data-name": "Group 1017"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1223",
  "data-name": "Path 1223",
  d: "M483.92,623.471l-.057,0a3.174,3.174,0,0,1-1.55-.6l-.042-.029a5.875,5.875,0,0,1-1.359-1.459c-.011-.017-.021-.033-.033-.048a11.954,11.954,0,0,1-1.135-2.218c-.007-.021-.014-.036-.021-.053l-.008-.018a20.858,20.858,0,0,1-.872-2.877c-.008-.026-.014-.059-.021-.091a30.58,30.58,0,0,1-.573-3.444l-.012-.1c-.061-.556-.111-1.133-.148-1.714l.16-.01c.036.579.086,1.153.147,1.706l.012.1a30.454,30.454,0,0,0,.57,3.427c.006.032.012.06.019.086a20.708,20.708,0,0,0,.865,2.857l.006.015c.009.02.017.04.024.06a11.8,11.8,0,0,0,1.116,2.18c.011.014.025.035.036.053a5.7,5.7,0,0,0,1.319,1.417l.038.027a3.017,3.017,0,0,0,1.474.577h.018l.039,0Z",
  transform: "translate(-478.091 -610.798)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1026",
  "data-name": "Group 1026",
  transform: "translate(1.586 0.782)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1025",
  "data-name": "Group 1025"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1024",
  "data-name": "Group 1024"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1023",
  "data-name": "Group 1023"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1022",
  "data-name": "Group 1022"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1224",
  "data-name": "Path 1224",
  d: "M400.682,620.036c-.127-.092-.254-.185-.379-.279-.385-.292-.761-.6-1.117-.928a16.938,16.938,0,0,1-1.3-1.323l-.07-.078a17.411,17.411,0,0,1-2.178-3.131l-.026-.049-.026-.049a17.549,17.549,0,0,1-1.412-3.5l.155-.044a17.375,17.375,0,0,0,1.4,3.471l.025.046c.01.017.019.034.028.052a17.268,17.268,0,0,0,2.155,3.1l.07.078a16.811,16.811,0,0,0,1.294,1.312c.352.321.724.63,1.105.919.124.094.25.186.377.278Z",
  transform: "translate(-394.168 -610.653)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1031",
  "data-name": "Group 1031",
  transform: "translate(2.843 0.787)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1030",
  "data-name": "Group 1030"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1029",
  "data-name": "Group 1029"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1028",
  "data-name": "Group 1028"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1027",
  "data-name": "Group 1027"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1225",
  "data-name": "Path 1225",
  d: "M415.034,622.527c-.057-.017-.112-.036-.169-.057-.038-.012-.08-.027-.122-.042l-.051-.018c-.149-.052-.3-.11-.452-.171l-.029-.012-.064-.026a14.332,14.332,0,0,1-3.044-1.713l-.081-.061a15.214,15.214,0,0,1-2.565-2.434c-.014-.015-.029-.033-.044-.052l-.021-.026a16.5,16.5,0,0,1-1.995-3.052c-.008-.014-.016-.031-.024-.047s-.015-.031-.023-.045a17.933,17.933,0,0,1-1.326-3.571c-.011-.038-.021-.075-.029-.11-.03-.12-.059-.242-.086-.363l.157-.035q.04.18.085.36c.008.034.018.069.027.1a17.785,17.785,0,0,0,1.314,3.541c.008.015.016.032.025.049l.022.043a16.341,16.341,0,0,0,1.976,3.023l.023.027c.013.016.026.032.04.047a15.053,15.053,0,0,0,2.541,2.412l.081.06a14.163,14.163,0,0,0,3.01,1.693l.061.024.031.012c.15.06.3.117.446.169l.052.019c.039.014.078.029.118.041.058.021.109.039.162.055Z",
  transform: "translate(-404.909 -610.692)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1036",
  "data-name": "Group 1036",
  transform: "translate(2.892 0.787)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1035",
  "data-name": "Group 1035"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1034",
  "data-name": "Group 1034"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1033",
  "data-name": "Group 1033"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1032",
  "data-name": "Group 1032"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1226",
  "data-name": "Path 1226",
  d: "M415.5,622.557l-.109-.037c-.044-.011-.1-.031-.156-.052-.038-.012-.08-.027-.122-.042l-.051-.019c-.144-.052-.288-.107-.432-.165l-.092-.037a14.215,14.215,0,0,1-3.034-1.709c-.03-.023-.054-.041-.078-.058a15.3,15.3,0,0,1-2.56-2.432l-.022-.027c-.013-.016-.026-.033-.04-.048a16.525,16.525,0,0,1-1.989-3.055c-.017-.031-.034-.063-.049-.1a18.051,18.051,0,0,1-1.321-3.564c-.01-.041-.017-.072-.026-.105-.031-.128-.062-.255-.091-.382l.156-.036c.028.127.059.253.089.377.009.033.017.066.025.1a17.924,17.924,0,0,0,1.313,3.543c.015.035.03.063.046.092a16.377,16.377,0,0,0,1.968,3.024c.013.014.028.033.044.052l.021.026a15.14,15.14,0,0,0,2.531,2.405c.024.017.05.036.076.056a14.067,14.067,0,0,0,3,1.693l.091.037c.142.057.284.112.426.163l.052.019c.039.015.078.029.118.041.058.021.109.039.162.055l.1.033Z",
  transform: "translate(-405.33 -610.689)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1041",
  "data-name": "Group 1041",
  transform: "translate(5.064 0.791)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1040",
  "data-name": "Group 1040"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1039",
  "data-name": "Group 1039"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1038",
  "data-name": "Group 1038"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1037",
  "data-name": "Group 1037"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1227",
  "data-name": "Path 1227",
  d: "M433.794,623.093c-.075-.016-.15-.034-.225-.052H433.5v-.019l-.016,0a10.064,10.064,0,0,1-1.552-.525l-.04-.016-.037-.015a11.189,11.189,0,0,1-2.6-1.608l-.067-.055A13.375,13.375,0,0,1,427,618.457c-.019-.028-.037-.052-.055-.075a16.229,16.229,0,0,1-1.7-2.983l-.04-.095a19.288,19.288,0,0,1-1.125-3.518c0-.019-.009-.039-.013-.06l-.01-.047c-.064-.3-.121-.6-.174-.924l.158-.026c.053.321.109.62.173.916l.01.049c0,.019.008.037.012.056a19.122,19.122,0,0,0,1.117,3.492l.039.094a16.072,16.072,0,0,0,1.677,2.95c.018.024.037.05.056.077a13.214,13.214,0,0,0,2.156,2.312l.067.055a11.024,11.024,0,0,0,2.556,1.583l.076.031a9.929,9.929,0,0,0,1.53.517l.134.034.173.039Z",
  transform: "translate(-423.891 -610.73)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1046",
  "data-name": "Group 1046",
  transform: "translate(1.561 0.782)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1045",
  "data-name": "Group 1045"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1044",
  "data-name": "Group 1044"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1043",
  "data-name": "Group 1043"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1042",
  "data-name": "Group 1042"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1228",
  "data-name": "Path 1228",
  d: "M400.983,620.372l-.18-.122-.039-.029c-.049-.032-.109-.074-.17-.117l-.022-.015c-.023-.018-.038-.029-.053-.04l-.033-.022c-.125-.091-.246-.18-.367-.273-.385-.291-.76-.6-1.116-.928a16.338,16.338,0,0,1-1.325-1.335c-.024-.026-.049-.056-.073-.083a17.32,17.32,0,0,1-2.18-3.13c-.013-.022-.027-.048-.04-.073l-.011-.022a17.662,17.662,0,0,1-1.413-3.488l.154-.044a17.509,17.509,0,0,0,1.4,3.457l.012.023c.012.023.024.046.037.068a17.164,17.164,0,0,0,2.162,3.1c.023.027.046.055.07.08a16.22,16.22,0,0,0,1.314,1.323c.353.321.725.63,1.106.919.12.092.24.18.36.268l.035.024c.018.013.037.026.054.04l.2.139.027.018.182.123Z",
  transform: "translate(-393.959 -610.652)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1055",
  "data-name": "Group 1055",
  transform: "translate(31.225 8.205)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1050",
  "data-name": "Group 1050",
  transform: "translate(0.057 0.07)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1049",
  "data-name": "Group 1049"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1048",
  "data-name": "Group 1048"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1047",
  "data-name": "Group 1047"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1229",
  "data-name": "Path 1229",
  d: "M647.978,674.695l0,0Z",
  transform: "translate(-647.974 -674.695)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1054",
  "data-name": "Group 1054"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1053",
  "data-name": "Group 1053"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1052",
  "data-name": "Group 1052"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1051",
  "data-name": "Group 1051"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1230",
  "data-name": "Path 1230",
  d: "M647.579,674.24l-.036-.072-.057-.056.022-.018.078.141-.039-.07.058.055Z",
  transform: "translate(-647.486 -674.094)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1060",
  "data-name": "Group 1060"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1059",
  "data-name": "Group 1059"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1058",
  "data-name": "Group 1058"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1057",
  "data-name": "Group 1057"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1056",
  "data-name": "Group 1056"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1231",
  "data-name": "Path 1231",
  className: "cls-4",
  d: "M380.615,603.967",
  transform: "translate(-380.615 -603.967)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1065",
  "data-name": "Group 1065",
  transform: "translate(1.598 0.724)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1064",
  "data-name": "Group 1064"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1063",
  "data-name": "Group 1063"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1062",
  "data-name": "Group 1062"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1061",
  "data-name": "Group 1061"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_196",
  "data-name": "Rectangle 196",
  width: 34.19,
  height: 0.161
}))))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1111",
  "data-name": "Group 1111",
  transform: "translate(172.905 290.357)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1070",
  "data-name": "Group 1070",
  transform: "translate(44.648)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1069",
  "data-name": "Group 1069"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1068",
  "data-name": "Group 1068"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1067",
  "data-name": "Group 1067"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1232",
  "data-name": "Path 1232",
  d: "M719.12,610.6l.35,1.079H720.6l-.915.667.35,1.079-.915-.667-.915.667.349-1.079-.915-.667h1.131Z",
  transform: "translate(-717.639 -610.6)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1074",
  "data-name": "Group 1074",
  transform: "translate(41.93 4.974)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1073",
  "data-name": "Group 1073"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1072",
  "data-name": "Group 1072"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1071",
  "data-name": "Group 1071"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1233",
  "data-name": "Path 1233",
  d: "M695.889,653.114l.35,1.079h1.131l-.915.667.349,1.079-.915-.667-.915.667.349-1.079-.915-.667h1.131Z",
  transform: "translate(-694.408 -653.114)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1078",
  "data-name": "Group 1078",
  transform: "translate(38.163 9.148)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1077",
  "data-name": "Group 1077"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1076",
  "data-name": "Group 1076"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1075",
  "data-name": "Group 1075"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1234",
  "data-name": "Path 1234",
  d: "M663.7,688.782l.35,1.079h1.131l-.915.667.35,1.079-.915-.667-.915.667.35-1.079-.915-.667h1.131Z",
  transform: "translate(-662.22 -688.782)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1082",
  "data-name": "Group 1082",
  transform: "translate(33.524 12.345)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1081",
  "data-name": "Group 1081"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1080",
  "data-name": "Group 1080"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1079",
  "data-name": "Group 1079"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1235",
  "data-name": "Path 1235",
  d: "M624.049,716.11l.35,1.079h1.131l-.915.667.349,1.079-.915-.667-.915.667.349-1.079-.915-.667H623.7Z",
  transform: "translate(-622.569 -716.11)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1086",
  "data-name": "Group 1086",
  transform: "translate(28.186 14.392)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1085",
  "data-name": "Group 1085"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1084",
  "data-name": "Group 1084"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1083",
  "data-name": "Group 1083"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1236",
  "data-name": "Path 1236",
  d: "M578.426,733.6l.35,1.079h1.131l-.915.667.35,1.079-.915-.667-.915.667.35-1.079-.915-.667h1.131Z",
  transform: "translate(-576.945 -733.602)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1090",
  "data-name": "Group 1090",
  transform: "translate(22.324 15.113)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1089",
  "data-name": "Group 1089"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1088",
  "data-name": "Group 1088"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1087",
  "data-name": "Group 1087"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1237",
  "data-name": "Path 1237",
  d: "M528.324,739.765l.349,1.079H529.8l-.915.667.35,1.079-.915-.667-.915.667.35-1.079-.915-.667h1.131Z",
  transform: "translate(-526.844 -739.765)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1094",
  "data-name": "Group 1094",
  transform: "translate(16.461 14.392)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1093",
  "data-name": "Group 1093"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1092",
  "data-name": "Group 1092"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1091",
  "data-name": "Group 1091"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1238",
  "data-name": "Path 1238",
  d: "M478.217,733.6l.349,1.079H479.7l-.915.667.349,1.079-.915-.667-.915.667.349-1.079-.915-.667h1.131Z",
  transform: "translate(-476.736 -733.602)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1098",
  "data-name": "Group 1098",
  transform: "translate(11.122 12.345)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1097",
  "data-name": "Group 1097"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1096",
  "data-name": "Group 1096"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1095",
  "data-name": "Group 1095"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1239",
  "data-name": "Path 1239",
  d: "M432.592,716.109l.349,1.079h1.131l-.915.667.35,1.079-.915-.667-.915.667.349-1.079-.915-.667h1.131Z",
  transform: "translate(-431.111 -716.109)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1102",
  "data-name": "Group 1102",
  transform: "translate(6.483 9.148)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1101",
  "data-name": "Group 1101"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1100",
  "data-name": "Group 1100"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1099",
  "data-name": "Group 1099"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1240",
  "data-name": "Path 1240",
  d: "M392.941,688.781l.35,1.079h1.131l-.915.667.35,1.079-.915-.667-.915.667.349-1.079-.915-.667h1.131Z",
  transform: "translate(-391.46 -688.781)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1106",
  "data-name": "Group 1106",
  transform: "translate(2.717 4.974)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1105",
  "data-name": "Group 1105"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1104",
  "data-name": "Group 1104"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1103",
  "data-name": "Group 1103"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1241",
  "data-name": "Path 1241",
  d: "M360.757,653.113l.35,1.079h1.131l-.915.667.35,1.079-.915-.667-.915.667.35-1.079-.915-.667h1.131Z",
  transform: "translate(-359.276 -653.113)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1110",
  "data-name": "Group 1110"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1109",
  "data-name": "Group 1109"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1108",
  "data-name": "Group 1108"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1107",
  "data-name": "Group 1107"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1242",
  "data-name": "Path 1242",
  d: "M337.533,610.6l.35,1.079h1.131l-.915.667.349,1.079-.915-.667-.915.667.35-1.079-.915-.667h1.131Z",
  transform: "translate(-336.052 -610.6)"
})))))));

var SvgCommunityLogo = function SvgCommunityLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90.964,
    height: 68.349,
    viewBox: "0 0 90.964 68.349",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCommunityLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CommunityLogo.d56adf57.svg";
export { ForwardRef as ReactComponent };